(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7661],{

/***/ 21926:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[username]/posts/[postId]",
      function () {
        return __webpack_require__(68656);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useMountedDelay; }
/* harmony export */ });
/* unused harmony export useMounted */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useMounted = function() {
    var ref = useState(false), mounted = ref[0], setMounted = ref[1];
    useEffect(function() {
        setMounted(true);
    }, []);
    return mounted;
};
var useMountedDelay = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var delay = setTimeout(function() {
            setMounted(true);
        }, 500);
        return function() {
            delay && clearTimeout(delay);
            setMounted(true);
        };
    }, []);
    return mounted;
};


/***/ }),

/***/ 60612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fq": function() { return /* binding */ CHECK_3DS_CODE; },
/* harmony export */   "GQ": function() { return /* binding */ isHavingPlusBenefits; },
/* harmony export */   "If": function() { return /* binding */ isSubbedPrimePlusBefore; },
/* harmony export */   "Vj": function() { return /* binding */ ableToShowSubscribingStatusModal; },
/* harmony export */   "W$": function() { return /* binding */ isPayingPlus; },
/* harmony export */   "WJ": function() { return /* binding */ isRenewPrimeSubStatus; },
/* harmony export */   "_I": function() { return /* binding */ isPayingPrimeSub; },
/* harmony export */   "bG": function() { return /* binding */ isHavingPrimeBenefits; },
/* harmony export */   "bm": function() { return /* binding */ showingPrimeSubPrice; },
/* harmony export */   "r$": function() { return /* binding */ isSubbingPrimeByCoin; },
/* harmony export */   "uj": function() { return /* binding */ getPrimePlusPackageStatus; },
/* harmony export */   "zB": function() { return /* binding */ plusPackageStatusText; }
/* harmony export */ });
/* unused harmony export isAbleToCreatorNewPrimeSub */
/* harmony import */ var common_interfaces_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21694);
/* harmony import */ var service_payment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43827);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22467);



var CHECK_3DS_CODE = "3DS-authentication-complete";
// having plus benefits
var isHavingPlusBenefits = function(creator) {
    var ref;
    if (!creator) return false;
    var primePlusPackStatus = creator === null || creator === void 0 ? void 0 : (ref = creator.option_creator_subscriptions) === null || ref === void 0 ? void 0 : ref.find(function(option) {
        return option.optional_type === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .OptionalPackageName.Plus */ .vq.Plus;
    });
    if (!primePlusPackStatus) return false;
    if ((primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "active" || (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "trialing" || (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "canceled") return true;
    if (primePlusPackStatus.ended_at) return primePlusPackStatus.ended_at && new Date(primePlusPackStatus.ended_at) > new Date();
};
var getPrimePlusPackageStatus = function(creator) {
    var ref;
    if (!creator) return null;
    return creator === null || creator === void 0 ? void 0 : (ref = creator.option_creator_subscriptions) === null || ref === void 0 ? void 0 : ref.find(function(option) {
        return option.optional_type === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .OptionalPackageName.Plus */ .vq.Plus;
    });
};
// paying for plus benefits
var isPayingPlus = function(creator) {
    var ref;
    if (!creator) return false;
    var primePlusPackStatus = creator === null || creator === void 0 ? void 0 : (ref = creator.option_creator_subscriptions) === null || ref === void 0 ? void 0 : ref.find(function(option) {
        return option.optional_type === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .OptionalPackageName.Plus */ .vq.Plus;
    });
    if (!primePlusPackStatus) return false;
    return (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "active" || (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "trialing" || (primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status) === "unpaid";
};
var isSubbingPrimeByCoin = function(creator) {
    var ref;
    if (!creator) return false;
    return [
        "web_coin",
        "android_coin",
        "ios_coin"
    ].includes(creator === null || creator === void 0 ? void 0 : (ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.platform);
};
var isSubbedPrimePlusBefore = function(creator) {
    var ref;
    if (!creator) return false;
    var primePlusPackStatus = creator === null || creator === void 0 ? void 0 : (ref = creator.option_creator_subscriptions) === null || ref === void 0 ? void 0 : ref.find(function(option) {
        return option.optional_type === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .OptionalPackageName.Plus */ .vq.Plus;
    });
    if (!primePlusPackStatus) return false;
    return !!(primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.is_subscribed_before);
};
var ableToShowSubscribingStatusModal = function(creator) {
    if (!creator) return false;
    return isHavingPlusBenefits(creator) || isRenewPrimeSubStatus(creator) || isPayingPrimeSub(creator);
};
var plusPackageStatusText = function(primePlusPackStatus) {
    if (!primePlusPackStatus) return "";
    switch(primePlusPackStatus === null || primePlusPackStatus === void 0 ? void 0 : primePlusPackStatus.status){
        case "active":
            return "登録中";
        case "trialing":
            return "無料体験中";
        case "canceled":
            return "残り".concat((0,___WEBPACK_IMPORTED_MODULE_2__/* .timeUntil */ .LW)(new Date(primePlusPackStatus.ended_at), common_interfaces_api__WEBPACK_IMPORTED_MODULE_0__/* .Language.Ja */ .SQ.Ja));
        default:
            return "";
    }
};
var isRenewPrimeSubStatus = function(creator) {
    var ref;
    if (!creator) return false;
    return (creator === null || creator === void 0 ? void 0 : (ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.status) === "canceled";
};
var isPayingPrimeSub = function(creator) {
    var ref, ref1, ref2;
    if (!creator) return false;
    return (creator === null || creator === void 0 ? void 0 : (ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.status) === "active" || (creator === null || creator === void 0 ? void 0 : (ref1 = creator.creator_subscription) === null || ref1 === void 0 ? void 0 : ref1.status) === "trialing" || (creator === null || creator === void 0 ? void 0 : (ref2 = creator.creator_subscription) === null || ref2 === void 0 ? void 0 : ref2.status) === "unpaid";
};
var isAbleToCreatorNewPrimeSub = function(creator) {
    var ref;
    return !(creator === null || creator === void 0 ? void 0 : (ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.status) || isRenewPrimeSubStatus(creator);
};
var isHavingPrimeBenefits = function(creator) {
    var ref, ref1, ref2;
    if (!creator) return false;
    return (creator === null || creator === void 0 ? void 0 : (ref = creator.creator_subscription) === null || ref === void 0 ? void 0 : ref.status) === "active" || (creator === null || creator === void 0 ? void 0 : (ref1 = creator.creator_subscription) === null || ref1 === void 0 ? void 0 : ref1.status) === "trialing" || (creator === null || creator === void 0 ? void 0 : (ref2 = creator.creator_subscription) === null || ref2 === void 0 ? void 0 : ref2.status) === "canceled";
};
var showingPrimeSubPrice = function(pack, discountByMembershipWebAmount, currentPaymentBy) {
    if (discountByMembershipWebAmount > 0 && (pack === null || pack === void 0 ? void 0 : pack.recurring) === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .WebPricePackageRecurring.Month */ .a5.Month && currentPaymentBy === "coin") {
        return discountByMembershipWebAmount;
    }
    if ((pack === null || pack === void 0 ? void 0 : pack.recurring) === service_payment__WEBPACK_IMPORTED_MODULE_1__/* .WebPricePackageRecurring.Month */ .a5.Month && currentPaymentBy === "coin") {
        return pack === null || pack === void 0 ? void 0 : pack.original_web_amount;
    }
    return pack === null || pack === void 0 ? void 0 : pack.discounted_web_amount;
};


/***/ }),

/***/ 32954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TimelineSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87066);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88767);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(21190);
/* harmony import */ var components_Post__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53704);
/* harmony import */ var common_interfaces_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21694);
/* harmony import */ var store_timeline__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12800);
/* harmony import */ var store_global__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8405);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37975);
/* harmony import */ var components_common_InfiniteScroll__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68330);
/* harmony import */ var _TimelineSection_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16081);
/* harmony import */ var _TimelineSection_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_TimelineSection_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var components_common_PreloadContentLoader__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60782);
/* harmony import */ var common_utils_hooks_useDidMount__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86177);
















function TimelineSection(param) {
    var apiUrl = param.apiUrl, queryKey = param.queryKey, _queryParamKey = param.queryParamKey, queryParamKey = _queryParamKey === void 0 ? "last_post_id" : _queryParamKey, _getNextPageParam = param.getNextPageParam, getNextPageParam = _getNextPageParam === void 0 ? function(lastPage) {
        var ref;
        var posts = lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.posts;
        if (posts && posts.length > 0) {
            var lastPost = posts[posts.length - 1];
            return lastPost.id;
        }
    } : _getNextPageParam, _noResultMessage = param.noResultMessage, noResultMessage = _noResultMessage === void 0 ? "投稿はありません" : _noResultMessage, _disableInfiniteScroll = param.disableInfiniteScroll, disableInfiniteScroll = _disableInfiniteScroll === void 0 ? false : _disableInfiniteScroll, _hideNoResult = param.hideNoResult, hideNoResult = _hideNoResult === void 0 ? false : _hideNoResult, _defaultPageParam = param.defaultPageParam, defaultPageParam = _defaultPageParam === void 0 ? 0 : _defaultPageParam, subQuery = param.subQuery;
    var shouldRefetchPosts = (0,store_timeline__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(function(state) {
        return state.shouldRefetchPosts;
    });
    var isAuthInit = (0,store_global__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(state) {
        return state.isAuthInit;
    });
    var currentAuth = (0,store_global__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(state) {
        return state.currentAuth;
    });
    var mounted = (0,common_utils_hooks_useDidMount__WEBPACK_IMPORTED_MODULE_11__/* .useMountedDelay */ ._)();
    var usingMounted = currentAuth ? true : mounted;
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useInfiniteQuery)(queryKey, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var _pageParam, pageParam, query, filterParam, subQueryParam, url;
            return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? defaultPageParam : _pageParam;
                        if (!(!isAuthInit || !usingMounted)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject());
                    case 3:
                        query = "".concat(queryParamKey, "=").concat(String(pageParam));
                        filterParam = queryKey && queryKey[0] === common_interfaces_api__WEBPACK_IMPORTED_MODULE_5__/* .PostParentKey.UnReadPosts */ .rO.UnReadPosts ? "&unread=true" : "";
                        subQueryParam = subQuery ? "&".concat(subQuery.key, "=").concat(subQuery.value) : "";
                        url = "".concat(apiUrl, "?").concat(query).concat(filterParam).concat(subQueryParam);
                        _ctx.next = 9;
                        return axios__WEBPACK_IMPORTED_MODULE_13__/* ["default"].get */ .Z.get(url);
                    case 9:
                        return _ctx.abrupt("return", _ctx.sent.data);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        getNextPageParam: getNextPageParam,
        // TODO: somehow enabled is not working as intended
        // useInfiniteQuery still runs when enabled is false
        // this is currently handled by only shows this component when isAuthInit is true
        enabled: isAuthInit && usingMounted,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 15 * 60 * 1000,
        cacheTime: 15 * 60 * 1000
    }), isLoading = ref.isLoading, data = ref.data, fetchNextPage = ref.fetchNextPage, refetch = ref.refetch, isFetchingNextPage = ref.isFetchingNextPage, isFetched = ref.isFetched;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (shouldRefetchPosts) {
            void refetch();
        }
    }, [
        shouldRefetchPosts,
        refetch
    ]);
    var pages = data === null || data === void 0 ? void 0 : data.pages;
    var posts = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return pages ? pages.reduce(function(curr, page) {
            var ref;
            var posts = ((ref = page.data) === null || ref === void 0 ? void 0 : ref.posts) || [];
            return curr.concat(posts);
        }, []) : [];
    }, [
        pages
    ]);
    var noPostPlaceholder;
    if (!isLoading && posts.length === 0 && !hideNoResult) {
        noPostPlaceholder = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (_TimelineSection_module_scss__WEBPACK_IMPORTED_MODULE_14___default().noPost),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                    name: "empty",
                    width: 96,
                    height: 96
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: noResultMessage
                    }
                })
            ]
        });
    }
    // Animation
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), doUseAnimation = ref1[0], setUseAnimation = ref1[1];
    // Prevent animation from playing on first load
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var timeout;
        if (!isLoading) {
            timeout = setTimeout(function() {
                return setUseAnimation(true);
            });
        }
        return function() {
            clearTimeout(timeout);
            setUseAnimation(false);
        };
    }, [
        isLoading
    ]);
    if (!queryKey || !queryKey[0]) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
    var postsRender = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_15__/* .AnimatePresence */ .M, {
        initial: false,
        children: posts.map(function(post, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_TimelineSection_module_scss__WEBPACK_IMPORTED_MODULE_14___default().post),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Post__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    post: post,
                    shouldAnimate: doUseAnimation,
                    parent: String(queryKey[0]),
                    hasFollowBtn: true,
                    isPinned: queryKey[0] === common_interfaces_api__WEBPACK_IMPORTED_MODULE_5__/* .PostParentKey.ProfilePosts */ .rO.ProfilePosts && post.is_pinned
                })
            }, "".concat(post === null || post === void 0 ? void 0 : post.id, "-").concat(index));
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (_TimelineSection_module_scss__WEBPACK_IMPORTED_MODULE_14___default().timelineWrapper),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_InfiniteScroll__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                fetchNextPage: fetchNextPage,
                disabled: disableInfiniteScroll,
                isLoading: isFetchingNextPage,
                children: isFetched ? postsRender : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_PreloadContentLoader__WEBPACK_IMPORTED_MODULE_10__/* .PostsLoader */ .DN, {})
            }),
            noPostPlaceholder
        ]
    });
};


/***/ }),

/***/ 2298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _PostTopicItem_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26759);
/* harmony import */ var _PostTopicItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_PostTopicItem_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var PostTopicItem = function(param) {
    var text = param.text, isActive = param.isActive, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? 8 : _fontSize, _color = param.color, color = _color === void 0 ? "#CCCCCC" : _color, _background = param.background, background = _background === void 0 ? "#EEEEEE" : _background;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_PostTopicItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().postTopicItem), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_PostTopicItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active), isActive)),
        style: {
            fontSize: "".concat(fontSize, "px"),
            color: color,
            background: background
        },
        children: text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostTopicItem);


/***/ }),

/***/ 68656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _postId_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/common/Icon/index.tsx
var Icon = __webpack_require__(37975);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./store/global.ts
var global = __webpack_require__(8405);
// EXTERNAL MODULE: ./common/interfaces/api.ts
var api = __webpack_require__(21694);
// EXTERNAL MODULE: ./common/utils/index.ts + 1 modules
var utils = __webpack_require__(22467);
// EXTERNAL MODULE: ./store/timeline.ts
var timeline = __webpack_require__(12800);
// EXTERNAL MODULE: ./components/Post/ThreeDotsMenu/index.tsx
var ThreeDotsMenu = __webpack_require__(73160);
// EXTERNAL MODULE: ./components/common/UserInfo/index.tsx
var UserInfo = __webpack_require__(92371);
// EXTERNAL MODULE: ./components/common/LockedMessage/LockedMessage.module.scss
var LockedMessage_module = __webpack_require__(77037);
var LockedMessage_module_default = /*#__PURE__*/__webpack_require__.n(LockedMessage_module);
// EXTERNAL MODULE: ./components/common/Button/index.tsx
var Button = __webpack_require__(98133);
// EXTERNAL MODULE: ./common/utils/membership.ts
var membership = __webpack_require__(77063);
// EXTERNAL MODULE: ./common/utils/pp_tracking.ts
var pp_tracking = __webpack_require__(67027);
// EXTERNAL MODULE: ./common/utils/post.ts
var utils_post = __webpack_require__(40783);
// EXTERNAL MODULE: ./common/utils/payment.ts
var payment = __webpack_require__(60612);
;// CONCATENATED MODULE: ./components/common/LockedMessage/index.tsx











var LockedType;
(function(LockedType) {
    LockedType["Text"] = "text";
    LockedType["Image"] = "image";
    LockedType["Video"] = "video";
    LockedType["Audio"] = "audio";
})(LockedType || (LockedType = {}));
function LockedMessage(param) {
    var type = param.type, postAuthor = param.postAuthor, postType = param.postType;
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var showPaymentDialog = (0,global/* default */.Z)(function(state) {
        return state.showPaymentDialog;
    });
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var setShowMembershipPayDialog = (0,global/* default */.Z)(function(state) {
        return state.setShowMembershipPayDialog;
    });
    var content;
    if (currentUser) {
        var handleTrialClick = function() {
            if (postType === api/* PostType.Gold */.hQ.Gold && !(0,membership/* isGoldMember */.Ic)(currentUser)) {
                setShowMembershipPayDialog({
                    open: true,
                    showMembershipStatus: false,
                    initPackage: api/* MembershipPackageName.Platinum */.uh.Platinum,
                    screen: pp_tracking/* ScreenName.PostDetail */.CG.PostDetail
                });
                return;
            }
            if (!postAuthor) return;
            // in case of value is undefined, still can open payment dialog
            if (postAuthor.is_open_for_subscription === false && (0,utils_post/* checkIsCreatorPaidPost */.b8)(postType)) {
                setSnackbarMessage({
                    type: "error",
                    text: (0,utils_post/* exCreatorPostLockMessage */.e8)(postType)
                });
                return;
            }
            showPaymentDialog({
                creator: postAuthor
            });
        };
        var actionBtnText = function() {
            if (postType === api/* PostType.Gold */.hQ.Gold && !(0,membership/* isGoldMember */.Ic)(currentUser)) {
                return "GOLDメンバーシップに登録して視聴しましょう";
            }
            if (postType === api/* PostType.Paid */.hQ.Paid) {
                return (postAuthor === null || postAuthor === void 0 ? void 0 : postAuthor.is_subscribed_before) ? "プライム登録を再開" : "プライム登録を無料体験";
            }
            if (postType === api/* PostType.Plus */.hQ.Plus) {
                return (0,payment/* isSubbedPrimePlusBefore */.If)(postAuthor) ? "プライムPlusを再開" : "プライムPlusを無料体験";
            }
        };
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (LockedMessage_module_default()).registerBtn,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                text: actionBtnText(),
                onClick: function() {
                    return handleTrialClick();
                }
            })
        });
    } else {
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (LockedMessage_module_default()).registerBtn,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                text: "無料でログインする",
                onClick: function() {
                    return showLogin({
                        authorName: postAuthor.name
                    });
                }
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((LockedMessage_module_default()).lockedOverlay, (LockedMessage_module_default())[type]),
        children: content
    });
};

// EXTERNAL MODULE: ./components/common/RichContent/index.tsx + 1 modules
var RichContent = __webpack_require__(8348);
// EXTERNAL MODULE: ./components/PostDetails/PostDetails.module.scss
var PostDetails_module = __webpack_require__(8577);
var PostDetails_module_default = /*#__PURE__*/__webpack_require__.n(PostDetails_module);
// EXTERNAL MODULE: ./components/LitePost/index.tsx
var LitePost = __webpack_require__(42470);
// EXTERNAL MODULE: ./components/MediaContent/index.tsx + 4 modules
var MediaContent = __webpack_require__(4858);
// EXTERNAL MODULE: ./service/post.ts
var service_post = __webpack_require__(87350);
// EXTERNAL MODULE: ./components/common/LabelButton/index.tsx
var LabelButton = __webpack_require__(57307);
// EXTERNAL MODULE: ./components/PostDetails/TippedListOfPost/index.tsx
var TippedListOfPost = __webpack_require__(38619);
// EXTERNAL MODULE: ./components/common/TippedListDialog/index.tsx
var TippedListDialog = __webpack_require__(95160);
// EXTERNAL MODULE: ./components/common/PostTopicItem/index.tsx
var PostTopicItem = __webpack_require__(2298);
// EXTERNAL MODULE: ./components/common/NewPostReActions/index.tsx
var NewPostReActions = __webpack_require__(99147);
// EXTERNAL MODULE: ./lib/dayjs.ts
var dayjs = __webpack_require__(25916);
// EXTERNAL MODULE: ./components/common/LiveStreamCommentBox/index.tsx
var LiveStreamCommentBox = __webpack_require__(70946);
// EXTERNAL MODULE: ./components/common/LiveStreamComments/LiveStreamComments.module.scss
var LiveStreamComments_module = __webpack_require__(21994);
var LiveStreamComments_module_default = /*#__PURE__*/__webpack_require__.n(LiveStreamComments_module);
// EXTERNAL MODULE: ./components/common/RoundIcon/index.tsx
var RoundIcon = __webpack_require__(10184);
// EXTERNAL MODULE: ./components/common/TippedItem/index.tsx
var TippedItem = __webpack_require__(7923);
// EXTERNAL MODULE: ./node_modules/react-use-websocket/dist/index.js
var dist = __webpack_require__(37676);
// EXTERNAL MODULE: ./service/chat.ts
var chat = __webpack_require__(24940);
// EXTERNAL MODULE: ./common/utils/debounce.ts
var debounce = __webpack_require__(80582);
// EXTERNAL MODULE: ./node_modules/scroll-lock/dist/scroll-lock.js
var scroll_lock = __webpack_require__(76265);
;// CONCATENATED MODULE: ./components/common/LiveStreamComments/index.tsx

























var MAX_MESSAGES_COUNT = 200;
var LiveStreamComments = function(param) {
    var className = param.className, post = param.post, _tippedList = param.tippedList, tippedList = _tippedList === void 0 ? [] : _tippedList, _tippedCount = param.tippedCount, tippedCount = _tippedCount === void 0 ? 0 : _tippedCount, setOpenTippedList = param.setOpenTippedList, requestToken = param.requestToken, isLocked = param.isLocked;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)(post.is_liked), isLiked = ref5[0], setIsLiked = ref5[1];
    var ref6 = (0,react.useState)(post.is_shared), isShared = ref6[0], setIsShared = ref6[1];
    var showTippingDialog = (0,global/* default */.Z)(function(state) {
        return state.showTippingDialog;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var currentAuth = (0,global/* default */.Z)(function(state) {
        return state.currentAuth;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var ref7 = (0,react.useState)(false), onHover = ref7[0], setOnHover = ref7[1];
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    // const router = useRouter();
    // const isPostDetail = router.pathname.startsWith('/[username]/posts/[postId]');
    // const postId = router.query.postId as string;
    var setPostToShareByPopup = (0,global/* default */.Z)(function(state) {
        return state.setPostToShareByPopup;
    });
    var isSmallScreen = (0,utils/* useMediaQuery */.ac)("(max-width: 1200px)");
    var isMobileScreen = (0,utils/* useMediaQuery */.ac)("(max-width: 767px)");
    var maxShowTip = isMobileScreen ? 4 : isSmallScreen ? 6 : 8;
    var refetchTippedListOfPost = (0,timeline/* default */.ZP)(function(state) {
        return state.refetchTippedListOfPost;
    });
    var commentsRef = (0,react.useRef)();
    var messGroupId = (post === null || post === void 0 ? void 0 : (ref = post.streaming) === null || ref === void 0 ? void 0 : (ref1 = ref.message_group) === null || ref1 === void 0 ? void 0 : ref1.group_key) || "";
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (!document.body) return;
        if (onHover && ((ref = commentsRef.current) === null || ref === void 0 ? void 0 : ref.scrollHeight) > ((ref1 = commentsRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientHeight)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            (0,scroll_lock.disablePageScroll)();
        } else {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            (0,scroll_lock.enablePageScroll)();
        }
        return function() {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            (0,scroll_lock.enablePageScroll)();
        };
    }, [
        onHover
    ]);
    var debouncedScrollToBottom = (0,react.useMemo)(function() {
        return (0,debounce/* default */.Z)(function() {
            if (!commentsRef.current) return;
            commentsRef.current.scrollTop = commentsRef.current.scrollHeight;
        }, 500);
    }, []);
    var socketUrl = "".concat("wss://api.postprime.com/api/v1", "/chats/start/").concat(messGroupId, "?token=").concat(requestToken);
    var ref8 = (0,react.useState)([]), messageHistory = ref8[0], setMessageHistory = ref8[1];
    (0,es.useQuery)([
        "getMessByGroup",
        messGroupId === null || messGroupId === void 0 ? void 0 : messGroupId.toString()
    ], (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,chat/* getMessagesByGroup */.q)(messGroupId, 1));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        refetchOnWindowFocus: false,
        enabled: isAuthInit && !!currentAuth,
        onSuccess: function(data) {
            var ref;
            var mess = (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.messages) || [];
            setMessageHistory(mess.reverse().concat((0,utils/* clone */.d9)(messageHistory)));
            debouncedScrollToBottom();
        }
    });
    var ref9 = (0,dist/* default */.ZP)(socketUrl, {
        //Will attempt to reconnect on all close events, such as server shutting down
        shouldReconnect: function() {
            return true;
        }
    }, !!requestToken && !!messGroupId), sendJsonMessage = ref9.sendJsonMessage, lastMessage = ref9.lastMessage, readyState = ref9.readyState;
    var showMessages = (0,react.useCallback)(function(newMessage) {
        setMessageHistory(function(prev) {
            var newMessesList = prev.concat(newMessage);
            if (newMessesList.length > MAX_MESSAGES_COUNT) {
                return newMessesList.slice(-MAX_MESSAGES_COUNT);
            }
            return newMessesList;
        });
        debouncedScrollToBottom();
    }, [
        debouncedScrollToBottom
    ]);
    var debouncedshowMessages = (0,react.useMemo)(function() {
        return (0,debounce/* default */.Z)(showMessages, 10);
    }, [
        showMessages
    ]);
    (0,react.useEffect)(function() {
        setMessageHistory([]);
    }, [
        post.id
    ]);
    (0,react.useEffect)(function() {
        if (!refetchTippedListOfPost || !setMessageHistory) return;
        if (lastMessage !== null) {
            try {
                var newMess = JSON.parse(lastMessage.data);
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                debouncedshowMessages(newMess);
                if (newMess.type === api/* LiveChatType.Tip */.rI.Tip) {
                    refetchTippedListOfPost();
                }
            // eslint-disable-next-line no-empty
            } catch (error) {}
        }
    }, [
        debouncedshowMessages,
        lastMessage,
        refetchTippedListOfPost,
        setMessageHistory, 
    ]);
    var handleClickSendMessage = function(mess) {
        sendJsonMessage({
            type: api/* LiveChatType.Chat */.rI.Chat,
            message: mess
        });
    };
    (0,react.useEffect)(function() {
        setIsLiked(post.is_liked);
        setIsShared(post.is_shared);
    }, [
        post.is_shared,
        post.is_liked
    ]);
    var handleShareClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (currentAuth) {
                            _ctx.next = 3;
                            break;
                        }
                        showLogin({});
                        return _ctx.abrupt("return");
                    case 3:
                        if (!isShared) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return axios/* default.post */.Z.post("/posts/".concat(post.id, "/shares"), {});
                    case 8:
                        if (!isShared) {
                            setIsShared(true);
                        }
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](5);
                        console.error(_ctx.t0);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    11
                ]
            ]);
        }));
        return function handleShareClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLikeClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var action;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!currentAuth) {
                            _ctx.next = 7;
                            break;
                        }
                        action = isLiked ? "unlike" : "like";
                        if (isLiked) {
                            setIsLiked(false);
                        } else {
                            setIsLiked(true);
                        }
                        _ctx.next = 5;
                        return axios/* default.post */.Z.post("/posts/".concat(post.id, "/reaction?action=").concat(action), {});
                    case 5:
                        _ctx.next = 8;
                        break;
                    case 7:
                        {
                            showLogin({});
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLikeClick() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!post || !messGroupId) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((LiveStreamComments_module_default()).commentSection, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LiveStreamComments_module_default()).title,
                children: "LIVE CHAT"
            }),
            tippedList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LiveStreamComments_module_default()).tippedList,
                children: [
                    tippedList.slice(0, maxShowTip).map(function(tippedInfo, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TippedItem/* default */.Z, {
                            className: (LiveStreamComments_module_default()).tippedLabel,
                            tippedInfo: tippedInfo
                        }, "tip-".concat(index));
                    }),
                    tippedCount > maxShowTip && /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelButton/* default */.Z, {
                        text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (LiveStreamComments_module_default()).btnText,
                            children: [
                                "+",
                                tippedCount - maxShowTip
                            ]
                        }),
                        className: classnames_default()((LiveStreamComments_module_default()).tippedLabel, (LiveStreamComments_module_default()).loadmoreBtn),
                        type: "gray",
                        onClick: function() {
                            return setOpenTippedList && setOpenTippedList(true);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LiveStreamComments_module_default()).commentsList,
                ref: commentsRef,
                onMouseEnter: function() {
                    return setOnHover(true);
                },
                onMouseLeave: function() {
                    return setOnHover(false);
                },
                children: messageHistory.map(function(message, index) {
                    var ref, ref1, ref2, ref3, ref4, ref5;
                    var data = {
                        avatar_url: message.avatar_url || ((ref = message.user_info) === null || ref === void 0 ? void 0 : ref.avatar_url),
                        message: message.message,
                        created_at: message.created_at,
                        name: message.name || ((ref1 = message.user_info) === null || ref1 === void 0 ? void 0 : ref1.name) || message.username,
                        tip: message.tip || null,
                        type: message.type
                    };
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((LiveStreamComments_module_default()).comment, (0,_define_property/* default */.Z)({}, (LiveStreamComments_module_default())["tip-".concat((ref2 = data.tip) === null || ref2 === void 0 ? void 0 : ref2.id)], !!((ref3 = data.tip) === null || ref3 === void 0 ? void 0 : ref3.id))),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LiveStreamComments_module_default()).leftSide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundIcon/* default */.Z, {
                                    user: {
                                        avatar_url: data.avatar_url
                                    },
                                    width: 30,
                                    height: 30,
                                    enableClick: false,
                                    emotionSize: 15,
                                    emotion: // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                    data.tip ? api/* TipEmotion */.u7["Tip".concat(data.tip.id)] : null
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LiveStreamComments_module_default()).rightSide,
                                children: data.type === api/* LiveChatType.Tip */.rI.Tip ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (LiveStreamComments_module_default()).tipContent,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (LiveStreamComments_module_default()).userName,
                                            children: data.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelButton/* default */.Z, {
                                            text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "\xa5",
                                                    (ref4 = data.tip) === null || ref4 === void 0 ? void 0 : ref4.amount
                                                ]
                                            }),
                                            className: (LiveStreamComments_module_default()).tipping,
                                            type: "tip-".concat((ref5 = data.tip) === null || ref5 === void 0 ? void 0 : ref5.id)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (LiveStreamComments_module_default()).content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (LiveStreamComments_module_default()).userName,
                                            children: data.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (LiveStreamComments_module_default()).commentText,
                                            children: data.message
                                        })
                                    ]
                                })
                            })
                        ]
                    }, "mess-".concat(index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LiveStreamComments_module_default()).actionBox,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LiveStreamComments_module_default()).postReactions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (LiveStreamComments_module_default()).action,
                                onClick: function() {
                                    return handleLikeClick();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                        name: "heart",
                                        width: 20,
                                        height: 20,
                                        isOn: isLiked,
                                        hasOn: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LiveStreamComments_module_default()).numberWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (LiveStreamComments_module_default()).text,
                                            children: "いいね"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((LiveStreamComments_module_default()).action, (LiveStreamComments_module_default()).shareMenuTrigger),
                                onClick: function() {
                                    if (!currentAuth) {
                                        showLogin({});
                                        return;
                                    }
                                    void handleShareClick();
                                    setPostToShareByPopup(post);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                        name: "share",
                                        width: 20,
                                        height: 20,
                                        isOn: isShared,
                                        hasOn: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LiveStreamComments_module_default()).numberWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (LiveStreamComments_module_default()).text,
                                            children: "シェア"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((LiveStreamComments_module_default()).action, (LiveStreamComments_module_default()).thanks, (0,_define_property/* default */.Z)({}, (LiveStreamComments_module_default()).disabled, ((ref2 = post.user_info) === null || ref2 === void 0 ? void 0 : ref2.id) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) || !((ref3 = post.user_info) === null || ref3 === void 0 ? void 0 : ref3.is_creator) || !((ref4 = post.user_info) === null || ref4 === void 0 ? void 0 : ref4.is_open_for_subscription))),
                                onClick: function() {
                                    var ref;
                                    if (((ref = post.user_info) === null || ref === void 0 ? void 0 : ref.id) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)) return;
                                    showTippingDialog({
                                        post: post,
                                        isStreaming: true
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                        name: "thanks-icon",
                                        width: 20,
                                        height: 20
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LiveStreamComments_module_default()).numberWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (LiveStreamComments_module_default()).text,
                                            children: "ありがとう"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveStreamCommentBox/* default */.Z, {
                        sendMessage: handleClickSendMessage,
                        isAbleToComment: readyState === dist/* ReadyState.OPEN */.kQ.OPEN,
                        isLocked: isLocked,
                        postType: post.type,
                        creator: post.user_info
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var common_LiveStreamComments = (LiveStreamComments);

// EXTERNAL MODULE: ./components/common/PaidLabel/index.tsx
var PaidLabel = __webpack_require__(26063);
// EXTERNAL MODULE: ./components/common/InfiniteScroll/index.tsx
var InfiniteScroll = __webpack_require__(68330);
// EXTERNAL MODULE: ./components/SmallPostsListSection/SmallPostsListSection.module.scss
var SmallPostsListSection_module = __webpack_require__(92238);
var SmallPostsListSection_module_default = /*#__PURE__*/__webpack_require__.n(SmallPostsListSection_module);
// EXTERNAL MODULE: ./components/common/PreloadContentLoader/index.tsx + 1 modules
var PreloadContentLoader = __webpack_require__(60782);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/common/SmallPostBigThumb/SmallPost.module.scss
var SmallPost_module = __webpack_require__(72308);
var SmallPost_module_default = /*#__PURE__*/__webpack_require__.n(SmallPost_module);
// EXTERNAL MODULE: ./components/common/ViewedContent/index.tsx
var ViewedContent = __webpack_require__(85631);
// EXTERNAL MODULE: ./service/ads_tracking.ts
var ads_tracking = __webpack_require__(82752);
;// CONCATENATED MODULE: ./components/common/SmallPostBigThumb/index.tsx















function UnmemoizedSmallPostBigThumbItem(param) {
    var post = param.post, parent = param.parent, className = param.className;
    var ref, ref1, ref2;
    // Local post state so that edited content is shown immediately
    var router = (0,next_router.useRouter)();
    var isSmallScreen = (0,utils/* useMediaQuery */.ac)("(max-width: 1100px)");
    var postDetailsUrl = "/".concat(post.user_info.username, "/posts/").concat(post.id);
    var mediaContent = (0,react.useMemo)(function() {
        var ref;
        var media;
        if ((post === null || post === void 0 ? void 0 : post.streaming) && (post === null || post === void 0 ? void 0 : (ref = post.streaming) === null || ref === void 0 ? void 0 : ref.thumbnail)) {
            var ref1;
            media = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SmallPost_module_default()).media,
                onContextMenu: function(e) {
                    return e.preventDefault();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: post === null || post === void 0 ? void 0 : (ref1 = post.streaming) === null || ref1 === void 0 ? void 0 : ref1.thumbnail,
                        layout: "fill",
                        objectFit: "cover",
                        alt: "thumbnail"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SmallPost_module_default()).playBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "play",
                            width: 0.45 * 80,
                            height: 0.45 * 80
                        })
                    })
                ]
            });
        } else if ((post === null || post === void 0 ? void 0 : post.media) && post.media[0]) {
            if (post.media[0].type === api/* MediaType.Image */.DD.Image) {
                var ref2;
                var isBlur = !((ref2 = post.content_access) === null || ref2 === void 0 ? void 0 : ref2.is_authorized) && !!post.media[0].data.blur;
                media = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((SmallPost_module_default()).media, (0,_define_property/* default */.Z)({}, (SmallPost_module_default()).blurred, isBlur)),
                    onContextMenu: function(e) {
                        return e.preventDefault();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SmallPost_module_default()).imageWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: post.media[0].data.url,
                            layout: "fill",
                            objectFit: "cover",
                            alt: "thumbnail"
                        })
                    })
                });
            } else if (post.media[0].type === api/* MediaType.Video */.DD.Video) {
                media = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SmallPost_module_default()).media,
                    onContextMenu: function(e) {
                        return e.preventDefault();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: post.media[0].data.thumbnail_url,
                            layout: "fill",
                            objectFit: "cover",
                            alt: "thumbnail"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SmallPost_module_default()).playBtn,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                name: "play",
                                width: 0.45 * 80,
                                height: 0.45 * 80
                            })
                        })
                    ]
                });
            } else if (post.media[0].type === api/* MediaType.Link */.DD.Link) {
                if (post.is_affiliate) media = /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaAds, {
                    post: post,
                    parent: parent
                });
                else media = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SmallPost_module_default()).media,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: post.media[0].data.thumbnail_url,
                        layout: "fill",
                        objectFit: "cover",
                        alt: "thumbnail"
                    })
                });
            } else if (post.media[0].type === api/* MediaType.Audio */.DD.Audio) {
                media = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SmallPost_module_default()).media,
                    style: {
                        borderRadius: "6px",
                        background: "#0abc71"
                    },
                    children: [
                        post.media[0].data.thumbnail_url && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: post.media[0].data.thumbnail_url,
                            layout: "fill",
                            objectFit: "cover"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SmallPost_module_default()).playBtn,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                name: "audio-icon",
                                width: 30,
                                height: 33
                            })
                        })
                    ]
                });
            }
        } else {
            var ref3, ref4;
            media = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SmallPost_module_default()).media,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (ref3 = post.user_info) === null || ref3 === void 0 ? void 0 : ref3.avatar_url,
                    alt: (ref4 = post.user_info) === null || ref4 === void 0 ? void 0 : ref4.name,
                    className: (SmallPost_module_default()).avatar
                })
            });
        }
        return media;
    }, [
        parent,
        post
    ]);
    // Right side components
    var timeSinceText = (0,utils/* timeSince */.VG)(new Date(post.created_at), api/* Language.Ja */.SQ.Ja);
    // Handle clicking on post
    var postRef = (0,react.useRef)();
    var handlePostClick = function(e) {
        var selection = window.getSelection();
        if (selection.type != "Range" && // prevent portal from handling click event
        postRef.current.contains(e.target)) {
            void router.push(postDetailsUrl);
        }
    };
    var textContentWithoutEnter = (0,react.useMemo)(function() {
        var ref;
        return (ref = (0,utils/* textWithoutEnter */.GU)(post.text)) === null || ref === void 0 ? void 0 : ref.slice(0, isSmallScreen ? 100 : 40);
    }, [
        post.text,
        isSmallScreen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((SmallPost_module_default()).smallPostWrapper, className || ""),
        onClick: handlePostClick,
        ref: postRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SmallPost_module_default()).thumbnail,
                children: mediaContent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SmallPost_module_default()).contentWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SmallPost_module_default()).postTextWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SmallPost_module_default()).postText,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichContent/* default */.Z, {
                                text: textContentWithoutEnter || "無題"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (SmallPost_module_default()).userInfo,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (SmallPost_module_default()).userNameText,
                                title: (ref = post.user_info) === null || ref === void 0 ? void 0 : ref.name,
                                children: (ref1 = post.user_info) === null || ref1 === void 0 ? void 0 : ref1.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (SmallPost_module_default()).userJobText,
                                title: (ref2 = post.user_info) === null || ref2 === void 0 ? void 0 : ref2.job,
                                children: post.is_affiliate ? "Sponsored" : timeSinceText
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var MediaAds = function(param) {
    var post = param.post, parent = param.parent;
    var handleFirstImpression = function() {
        (0,ads_tracking/* adsTrackingCall */.E)({
            type: "ads_impression",
            parentType: parent,
            postId: post.id
        });
    };
    var handleClickLinkAds = function() {
        (0,ads_tracking/* adsTrackingCall */.E)({
            type: "ads_click",
            parentType: parent,
            postId: post.id
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewedContent/* default */.Z, {
        firstViewCallback: handleFirstImpression,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            onClick: function() {
                return handleClickLinkAds();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SmallPost_module_default()).media,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: post.media[0].data.thumbnail_url,
                    layout: "fill",
                    objectFit: "cover",
                    alt: "thumbnail"
                })
            })
        })
    });
};
/* harmony default export */ var SmallPostBigThumb = (/*#__PURE__*/react.memo(UnmemoizedSmallPostBigThumbItem));

;// CONCATENATED MODULE: ./components/SmallPostsListSection/index.tsx














function SmallPostsListSection(param) {
    var apiUrl = param.apiUrl, queryKey = param.queryKey, _queryParamKey = param.queryParamKey, queryParamKey = _queryParamKey === void 0 ? "last_post_id" : _queryParamKey, _getNextPageParam = param.getNextPageParam, getNextPageParam = _getNextPageParam === void 0 ? function(lastPage) {
        var ref;
        var posts = lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.posts;
        if (posts && posts.length > 0) {
            var lastPost = posts[posts.length - 1];
            return lastPost.id;
        }
    } : _getNextPageParam, _noResultMessage = param.noResultMessage, noResultMessage = _noResultMessage === void 0 ? "投稿はありません" : _noResultMessage, _disableInfiniteScroll = param.disableInfiniteScroll, disableInfiniteScroll = _disableInfiniteScroll === void 0 ? false : _disableInfiniteScroll, _hideNoResult = param.hideNoResult, hideNoResult = _hideNoResult === void 0 ? false : _hideNoResult, _defaultPageParam = param.defaultPageParam, defaultPageParam = _defaultPageParam === void 0 ? 0 : _defaultPageParam;
    var shouldRefetchPosts = (0,timeline/* default */.ZP)(function(state) {
        return state.shouldRefetchPosts;
    });
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var ref = (0,es.useInfiniteQuery)(queryKey, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _pageParam, pageParam, query, filterParam, url;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? defaultPageParam : _pageParam;
                        query = "".concat(queryParamKey, "=").concat(String(pageParam));
                        filterParam = queryKey && queryKey[0] === api/* PostParentKey.UnReadPosts */.rO.UnReadPosts ? "&unread=true" : "";
                        url = "".concat(apiUrl, "?").concat(query).concat(filterParam);
                        _ctx.next = 6;
                        return axios/* default.get */.Z.get(url);
                    case 6:
                        return _ctx.abrupt("return", _ctx.sent.data);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        getNextPageParam: getNextPageParam,
        // TODO: somehow enabled is not working as intended
        // useInfiniteQuery still runs when enabled is false
        // this is currently handled by only shows this component when isAuthInit is true
        enabled: isAuthInit,
        refetchOnWindowFocus: false
    }), isLoading = ref.isLoading, data = ref.data, fetchNextPage = ref.fetchNextPage, refetch = ref.refetch, isFetchingNextPage = ref.isFetchingNextPage, isFetched = ref.isFetched;
    (0,react.useEffect)(function() {
        if (shouldRefetchPosts) {
            void refetch();
        }
    }, [
        shouldRefetchPosts,
        refetch
    ]);
    var pages = data === null || data === void 0 ? void 0 : data.pages;
    var posts = (0,react.useMemo)(function() {
        return pages ? pages.reduce(function(curr, page) {
            var ref;
            var posts = ((ref = page.data) === null || ref === void 0 ? void 0 : ref.posts) || [];
            return curr.concat(posts);
        }, []) : [];
    }, [
        pages
    ]);
    var noPostPlaceholder;
    if (!isLoading && posts.length === 0 && !hideNoResult) {
        noPostPlaceholder = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (SmallPostsListSection_module_default()).noPost,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: "empty",
                    width: 96,
                    height: 96
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: noResultMessage
                    }
                })
            ]
        });
    }
    if (!queryKey || !queryKey[0]) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var postsRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: posts.map(function(post, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallPostBigThumb, {
                post: post,
                parent: String(queryKey[0]),
                className: (SmallPostsListSection_module_default()).post
            }, "".concat(post === null || post === void 0 ? void 0 : post.id, "-").concat(index));
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SmallPostsListSection_module_default()).timelineWrapper,
        children: [
            noPostPlaceholder,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
                fetchNextPage: fetchNextPage,
                disabled: disableInfiniteScroll,
                isLoading: isFetchingNextPage,
                children: isFetched ? postsRender : /*#__PURE__*/ (0,jsx_runtime.jsx)(PreloadContentLoader/* BigThumbSmallPostsLoader */.oT, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 168 modules
var motion = __webpack_require__(45489);
// EXTERNAL MODULE: ./components/PostComment/index.tsx + 1 modules
var PostComment = __webpack_require__(69847);
// EXTERNAL MODULE: ./components/common/CommentBox/index.tsx
var CommentBox = __webpack_require__(25043);
// EXTERNAL MODULE: ./components/PostCommentsSection/CommentsSection.module.scss
var CommentsSection_module = __webpack_require__(98089);
var CommentsSection_module_default = /*#__PURE__*/__webpack_require__.n(CommentsSection_module);
;// CONCATENATED MODULE: ./components/PostCommentsSection/index.tsx





















var PostCommentsSection = function(param) {
    var localPost = param.localPost;
    var ref;
    var shouldRefetchPostComments = (0,timeline/* default */.ZP)(function(state) {
        return state.shouldRefetchPostComments;
    });
    var setShowMembershipPayDialog = (0,global/* default */.Z)(function(state) {
        return state.setShowMembershipPayDialog;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var isScheduledPost = new Date(localPost.created_at) > new Date();
    var showPaymentDialog = (0,global/* default */.Z)(function(state) {
        return state.showPaymentDialog;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var isContentLocked = (0,utils_post/* checkIsContentLocked */.J8)(localPost);
    var onlyShowOneComment = isContentLocked;
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var ref1 = (0,es.useInfiniteQuery)([
        "getPostComments",
        (ref = localPost.id) === null || ref === void 0 ? void 0 : ref.toString()
    ], function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _pageParam, pageParam;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 0 : _pageParam;
                        _ctx.next = 3;
                        return axios/* default.get */.Z.get("/posts/".concat(localPost.id, "/comments?last_comment_id=").concat(pageParam));
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        getNextPageParam: function(lastPage) {
            var comments = lastPage === null || lastPage === void 0 ? void 0 : lastPage.data;
            if (comments && comments.length === utils/* COMMENTS_PER_PAGE */.Gu) {
                var lastId = comments[0].id;
                comments.forEach(function(comment) {
                    if (comment.id < lastId) {
                        lastId = comment.id;
                    }
                });
                return lastId;
            }
        },
        enabled: isAuthInit,
        refetchOnWindowFocus: false
    }), data = ref1.data, fetchNextPage = ref1.fetchNextPage, refetch = ref1.refetch, isFetchingNextPage = ref1.isFetchingNextPage;
    var pages = data === null || data === void 0 ? void 0 : data.pages;
    var comments = (0,react.useMemo)(function() {
        return pages ? pages.reduce(function(curr, page) {
            var comments = page.data;
            return (0,_to_consumable_array/* default */.Z)(curr).concat((0,_to_consumable_array/* default */.Z)(comments));
        }, []) : [];
    }, [
        pages
    ]);
    (0,react.useEffect)(function() {
        if (shouldRefetchPostComments) {
            void refetch();
        }
    }, [
        shouldRefetchPostComments,
        refetch
    ]);
    var handleReadmoreComment = (0,react.useCallback)(function() {
        if (!setSnackbarMessage || !showLogin || !showPaymentDialog || !setShowMembershipPayDialog) return;
        if (!currentUser) {
            showLogin({});
            return;
        }
        if (isContentLocked && localPost.type === api/* PostType.Gold */.hQ.Gold && !(0,membership/* isGoldMember */.Ic)(currentUser)) {
            setShowMembershipPayDialog({
                open: true,
                showMembershipStatus: false,
                screen: pp_tracking/* ScreenName.PostDetail */.CG.PostDetail
            });
            return;
        }
        if (localPost.user_info && isContentLocked && (0,utils_post/* checkIsCreatorPaidPost */.b8)(localPost.type)) {
            if (localPost.user_info.is_open_for_subscription === false) {
                setSnackbarMessage({
                    type: "error",
                    text: (0,utils_post/* exCreatorPostLockMessage */.e8)(localPost.type)
                });
                return;
            }
            showPaymentDialog({
                creator: localPost.user_info
            });
            return;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        setSnackbarMessage,
        showLogin,
        showPaymentDialog,
        setShowMembershipPayDialog,
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.membership,
        localPost.type,
        localPost.user_info,
        isContentLocked, 
    ]);
    // Comments
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((CommentsSection_module_default()).comments, (0,_define_property/* default */.Z)({}, (CommentsSection_module_default()).tinyMode, onlyShowOneComment && comments.length >= 1)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CommentsSection_module_default()).commentBoxWrapper,
                children: currentUser && (!onlyShowOneComment || comments.length === 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentBox/* default */.Z, {
                    postId: localPost.id,
                    isLocked: isScheduledPost || isContentLocked || localPost.is_blocked,
                    lockMessage: (0,utils_post/* commentLockMessage */.no)(localPost, isContentLocked)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
                fetchNextPage: fetchNextPage,
                disabled: onlyShowOneComment,
                isLoading: isFetchingNextPage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                    initial: false,
                    children: (onlyShowOneComment ? comments.slice(0, 1) : comments).map(function(comment) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                            initial: {
                                opacity: 0,
                                y: -150
                            },
                            animate: {
                                opacity: 1,
                                y: 0
                            },
                            exit: {
                                opacity: 0,
                                x: "70%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CommentsSection_module_default()).comment,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostComment/* default */.Z, {
                                    comment: comment,
                                    postId: localPost.id,
                                    isBlocked: localPost.is_blocked,
                                    postOwner: localPost.user_info,
                                    level: 0,
                                    isLocked: isContentLocked,
                                    parentId: null,
                                    tinyMode: onlyShowOneComment
                                })
                            }, comment.id)
                        }, comment.id);
                    })
                })
            }),
            onlyShowOneComment && comments.length >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CommentsSection_module_default()).more,
                onClick: function() {
                    return handleReadmoreComment();
                },
                children: "コメントを見る"
            })
        ]
    });
};
/* harmony default export */ var components_PostCommentsSection = (PostCommentsSection);

// EXTERNAL MODULE: ./components/CommentsSection/CommentsSection.module.scss
var CommentsSection_CommentsSection_module = __webpack_require__(48201);
var CommentsSection_CommentsSection_module_default = /*#__PURE__*/__webpack_require__.n(CommentsSection_CommentsSection_module);
;// CONCATENATED MODULE: ./components/CommentsSection/index.tsx





















var CommentsSection = function(param) {
    var localPost = param.localPost, userWantShowComments = param.userWantShowComments;
    var ref;
    var shouldRefetchPostComments = (0,timeline/* default */.ZP)(function(state) {
        return state.shouldRefetchPostComments;
    });
    var setShowMembershipPayDialog = (0,global/* default */.Z)(function(state) {
        return state.setShowMembershipPayDialog;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var isScheduledPost = new Date(localPost.created_at) > new Date();
    var showPaymentDialog = (0,global/* default */.Z)(function(state) {
        return state.showPaymentDialog;
    });
    var ref1 = (0,react.useState)(true), onlyShowOneComment = ref1[0], setOnlyShowOneComment = ref1[1];
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var isContentLocked = (0,utils_post/* checkIsContentLocked */.J8)(localPost);
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var ref2 = (0,es.useInfiniteQuery)([
        "getPostComments",
        (ref = localPost.id) === null || ref === void 0 ? void 0 : ref.toString()
    ], function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _pageParam, pageParam;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 0 : _pageParam;
                        _ctx.next = 3;
                        return axios/* default.get */.Z.get("/posts/".concat(localPost.id, "/comments?last_comment_id=").concat(pageParam));
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        getNextPageParam: function(lastPage) {
            var comments = lastPage === null || lastPage === void 0 ? void 0 : lastPage.data;
            if (comments && comments.length === utils/* COMMENTS_PER_PAGE */.Gu) {
                var lastId = comments[0].id;
                comments.forEach(function(comment) {
                    if (comment.id < lastId) {
                        lastId = comment.id;
                    }
                });
                return lastId;
            }
        },
        enabled: isAuthInit,
        refetchOnWindowFocus: false
    }), data = ref2.data, fetchNextPage = ref2.fetchNextPage, refetch = ref2.refetch, isFetchingNextPage = ref2.isFetchingNextPage;
    var pages = data === null || data === void 0 ? void 0 : data.pages;
    var comments = (0,react.useMemo)(function() {
        return pages ? pages.reduce(function(curr, page) {
            var comments = page.data;
            return (0,_to_consumable_array/* default */.Z)(curr).concat((0,_to_consumable_array/* default */.Z)(comments));
        }, []) : [];
    }, [
        pages
    ]);
    (0,react.useEffect)(function() {
        if (shouldRefetchPostComments) {
            void refetch();
        }
    }, [
        shouldRefetchPostComments,
        refetch
    ]);
    var handleReadmoreComment = (0,react.useCallback)(function() {
        if (!setSnackbarMessage || !showLogin || !showPaymentDialog || !setShowMembershipPayDialog) return;
        if (!currentUser) {
            showLogin({});
            return;
        }
        if (isContentLocked && localPost.type === api/* PostType.Gold */.hQ.Gold && !(0,membership/* isGoldMember */.Ic)(currentUser)) {
            setShowMembershipPayDialog({
                open: true,
                showMembershipStatus: false,
                screen: pp_tracking/* ScreenName.PostDetail */.CG.PostDetail
            });
            return;
        }
        if (localPost.user_info && isContentLocked && (0,utils_post/* checkIsCreatorPaidPost */.b8)(localPost.type)) {
            if (localPost.user_info.is_open_for_subscription === false) {
                setSnackbarMessage({
                    type: "error",
                    text: (0,utils_post/* exCreatorPostLockMessage */.e8)(localPost.type)
                });
                return;
            }
            showPaymentDialog({
                creator: localPost.user_info
            });
            return;
        }
        if (onlyShowOneComment && comments.length >= 1) {
            setOnlyShowOneComment(false);
        }
    }, [
        setSnackbarMessage,
        showLogin,
        showPaymentDialog,
        setShowMembershipPayDialog,
        currentUser,
        localPost.type,
        localPost.user_info,
        isContentLocked,
        onlyShowOneComment,
        comments.length, 
    ]);
    (0,react.useEffect)(function() {
        setOnlyShowOneComment(true);
    }, [
        localPost === null || localPost === void 0 ? void 0 : localPost.id
    ]);
    (0,react.useEffect)(function() {
        if (userWantShowComments > 0) {
            handleReadmoreComment();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userWantShowComments
    ]);
    // Comments
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((CommentsSection_CommentsSection_module_default()).comments, (0,_define_property/* default */.Z)({}, (CommentsSection_CommentsSection_module_default()).tinyMode, onlyShowOneComment && comments.length >= 1)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CommentsSection_CommentsSection_module_default()).commentBoxWrapper,
                children: [
                    currentUser && (!onlyShowOneComment || comments.length === 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentBox/* default */.Z, {
                        postId: localPost.id,
                        isLocked: isScheduledPost || isContentLocked || localPost.is_blocked,
                        callback: function() {
                            return setOnlyShowOneComment(false);
                        },
                        lockMessage: (0,utils_post/* commentLockMessage */.no)(localPost, isContentLocked)
                    }),
                    !onlyShowOneComment && comments.length >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CommentsSection_CommentsSection_module_default()).more,
                        onClick: function() {
                            setOnlyShowOneComment(true);
                        },
                        children: "一部を表示"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
                fetchNextPage: fetchNextPage,
                disabled: onlyShowOneComment,
                isLoading: isFetchingNextPage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                    initial: false,
                    children: (onlyShowOneComment ? comments.slice(0, 1) : comments).map(function(comment) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                            initial: {
                                opacity: 0,
                                y: -150
                            },
                            animate: {
                                opacity: 1,
                                y: 0
                            },
                            exit: {
                                opacity: 0,
                                x: "70%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CommentsSection_CommentsSection_module_default()).comment,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostComment/* default */.Z, {
                                    comment: comment,
                                    postId: localPost.id,
                                    isBlocked: localPost.is_blocked,
                                    postOwner: localPost.user_info,
                                    level: 0,
                                    isLocked: isContentLocked,
                                    parentId: null,
                                    tinyMode: onlyShowOneComment
                                })
                            }, comment.id)
                        }, comment.id);
                    })
                })
            }),
            onlyShowOneComment && comments.length >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CommentsSection_CommentsSection_module_default()).more,
                onClick: function() {
                    return handleReadmoreComment();
                },
                children: "コメントを見る"
            })
        ]
    });
};
/* harmony default export */ var components_CommentsSection = (CommentsSection);

// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-browser/lib/esm/index.js + 159 modules
var esm = __webpack_require__(65972);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/PostDetails/index.tsx






































function PostDetails(param) {
    var post = param.post, tippedListOfPost = param.tippedListOfPost, tippedCount = param.tippedCount, _loadedPostWithAuth = param.loadedPostWithAuth, loadedPostWithAuth = _loadedPostWithAuth === void 0 ? false : _loadedPostWithAuth;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    // Local post state so that edited content is shown immediately
    var ref8 = (0,react.useState)(post), localPost = ref8[0], setLocalPost = ref8[1];
    var ref9 = (0,react.useState)(false), openTippedList = ref9[0], setOpenTippedList = ref9[1];
    var showTippingDialog = (0,global/* default */.Z)(function(state) {
        return state.showTippingDialog;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var currentAuth = (0,global/* default */.Z)(function(state) {
        return state.currentAuth;
    });
    var ref10 = (0,react.useState)(false), canSeeFreeMinutes = ref10[0], setCanSeeFreeMinutes = ref10[1];
    var ref11 = (0,react.useState)(false), reloadingLiveChat = ref11[0], setReloadingLiveChat = ref11[1];
    var requestToken = (0,global/* default */.Z)(function(state) {
        return state.requestToken;
    });
    var refetchPost = (0,timeline/* default */.ZP)(function(state) {
        return state.refetchPost;
    });
    var refetchProfile = (0,timeline/* default */.ZP)(function(state) {
        return state.refetchProfile;
    });
    var router = (0,next_router.useRouter)();
    var isMobileScreen = (0,utils/* useMediaQuery */.ac)("(max-width: 767px)");
    var isSmallScreen = (0,utils/* useMediaQuery */.ac)("(max-width: 1100px)");
    var showCreatePostDialog = (0,global/* default */.Z)(function(state) {
        return state.showCreatePostDialog;
    });
    var showPaymentDialog = (0,global/* default */.Z)(function(state) {
        return state.showPaymentDialog;
    });
    var showCreatePostDialogMobile = (0,global/* default */.Z)(function(state) {
        return state.showCreatePostDialogMobile;
    });
    var ref12 = (0,react.useState)(null), sharedPost = ref12[0], setSharedPost = ref12[1];
    var isOwnPost = localPost.is_my_post;
    var isContentLocked = (0,utils_post/* checkIsContentLocked */.J8)(localPost);
    var showingPrimeSubBtnHeader = !isOwnPost && loadedPostWithAuth && localPost.type === api/* PostType.Free */.hQ.Free && ((ref = localPost.user_info) === null || ref === void 0 ? void 0 : ref.is_creator) && ((ref1 = localPost.user_info) === null || ref1 === void 0 ? void 0 : ref1.is_open_for_subscription) && !localPost.is_subscription;
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var trackAmpEvent = function(eventName) {
        var ref, ref1, ref2, ref3, ref4;
        (0,esm/* track */.j)(eventName, {
            post_type: post.type,
            media_type: (ref = post.media) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.type,
            comment_count: post.comment_count,
            like_count: post.like_count,
            post_user_id: (ref2 = post.user_info) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.id) === null || ref3 === void 0 ? void 0 : ref3.toString(),
            is_followed: (ref4 = post.user_info) === null || ref4 === void 0 ? void 0 : ref4.is_followed
        });
    };
    // post props may change
    (0,react.useEffect)(function() {
        setLocalPost(post);
    }, [
        post
    ]);
    var isStreaming = ((ref2 = localPost.streaming) === null || ref2 === void 0 ? void 0 : ref2.id) && ((ref3 = localPost.streaming) === null || ref3 === void 0 ? void 0 : ref3.status) === api/* LiveStreamStatus.InLive */.zN.InLive && !!((ref4 = localPost.streaming) === null || ref4 === void 0 ? void 0 : ref4.path_hls);
    (0,react.useEffect)(function() {
        if (!localPost.media || !localPost.media[0] || localPost.media[0].type !== api/* MediaType.Link */.DD.Link) {
            setSharedPost(null);
            return;
        }
    }, [
        localPost
    ]);
    var ref13 = (0,es.useMutation)(function() {
        return axios/* default.get */.Z.get("/posts/".concat(localPost.id, "?use_token=true"));
    }, {
        onSuccess: function() {
            refetchProfile();
            refetchPost();
        },
        onError: function() {
            setSnackbarMessage({
                type: "error",
                text: "エラーが発生しました"
            });
        }
    }), unlockPost = ref13.mutate, isUnlocking = ref13.isLoading;
    var ref14 = (0,react.useState)(true), isShortMode = ref14[0], setShortMode = ref14[1];
    var ref15 = (0,react.useState)(true), hasShortMode = ref15[0], setHasShortMode = ref15[1];
    var textRef = (0,react.useCallback)(function(node) {
        var initShortMode = setTimeout(function() {
            if (node !== null) {
                var scrollHeight = node.scrollHeight;
                var clientHeight = node.clientHeight;
                setHasShortMode(scrollHeight > clientHeight);
            }
        }, 500);
        return function() {
            return clearTimeout(initShortMode);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        localPost.text
    ]);
    (0,react.useEffect)(function() {
        setShortMode(true);
        setReloadingLiveChat(true);
        var timeout = setTimeout(function() {
            setReloadingLiveChat(false);
        }, 2000);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        post === null || post === void 0 ? void 0 : post.id
    ]);
    var _obj;
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((PostDetails_module_default()).postText, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (PostDetails_module_default()).locked, isContentLocked), (0,_define_property/* default */.Z)(_obj, (PostDetails_module_default()).notShortMode, !isShortMode), (0,_define_property/* default */.Z)(_obj, (PostDetails_module_default()).showingLoadmore, !isContentLocked && hasShortMode && isShortMode), _obj)),
                ref: textRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RichContent/* default */.Z, {
                        text: isContentLocked ? (0,utils/* lockTextContent */.QH)(localPost.text) : localPost.text
                    }),
                    !isContentLocked && hasShortMode && isShortMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PostDetails_module_default()).readmoreWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (PostDetails_module_default()).readmore,
                            onClick: function() {
                                trackAmpEvent("Click Read More In Post Detail");
                                if (!currentAuth) {
                                    showLogin({});
                                    return;
                                }
                                (0,utils/* increaseViewCount */.wh)(localPost.id);
                                setShortMode(false);
                            },
                            children: "続きを読む"
                        })
                    }),
                    isContentLocked && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PostDetails_module_default()).lockedOverlay
                    })
                ]
            }),
            sharedPost && (!hasShortMode || !isShortMode) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PostDetails_module_default()).sharedPost,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LitePost/* default */.Z, {
                    post: sharedPost,
                    parent: api/* PostParentKey.PostDetail */.rO.PostDetail,
                    showReadMore: true
                })
            }),
            !isContentLocked && hasShortMode && (isShortMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function() {
                    setShortMode(true);
                    window.scrollTo(0, 0);
                },
                className: (PostDetails_module_default()).showLess,
                children: "一部を表示"
            })),
            loadedPostWithAuth && (isContentLocked || !currentAuth) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginBottom: "2px"
                },
                children: localPost.type !== api/* PostType.Gold */.hQ.Gold && currentUser && typeof currentUser.referral_token === "number" && currentUser.referral_token > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (PostDetails_module_default()).referralTokenUse,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "招待チケットを使用して、あと",
                                currentUser.referral_token,
                                "回、無料で",
                                isMobileScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "プライム投稿をご覧いただけます"
                            ]
                        }),
                        isUnlocking ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "loading-anim-3",
                            width: 24,
                            height: 24
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function() {
                                return unlockPost();
                            },
                            children: "プライム投稿を見る"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LockedMessage, {
                    type: LockedType.Text,
                    postAuthor: localPost.user_info,
                    postType: localPost.type
                })
            })
        ]
    });
    // Right side components
    var isScheduledPost = new Date(localPost.created_at) > new Date();
    var timeSinceText = isScheduledPost ? "".concat((0,dayjs/* default */.Z)(localPost.created_at).format("YYYY/MM/DD HH:mm"), "に公開予定") : (0,utils/* timeSince */.VG)(new Date(localPost.created_at), api/* Language.Ja */.SQ.Ja);
    var postTopicsList = (0,react.useMemo)(function() {
        if ((!localPost.domains || localPost.domains.length === 0) && (!localPost.symbols || localPost.symbols.length === 0)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (PostDetails_module_default()).postTopicLists,
            children: [
                (localPost.symbols || []).map(function(symbol) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PostDetails_module_default()).item,
                        onClick: function() {
                            if (!currentAuth) {
                                showLogin({
                                    redirectUrl: "/chart?id=".concat(symbol.id, "&tab=chart")
                                });
                                return;
                            }
                            void router.push("/chart?id=".concat(symbol.id, "&tab=chart"));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTopicItem/* default */.Z, {
                            text: symbol.name,
                            isActive: false,
                            color: "#fff",
                            background: "#04b56a",
                            fontSize: 9
                        })
                    }, "symbol-".concat(symbol.name));
                }),
                (localPost.domains || []).map(function(topic) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/post_topics/".concat(topic.name),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: classnames_default()((PostDetails_module_default()).item, (0,_define_property/* default */.Z)({}, (PostDetails_module_default()).disabled, topic.is_disabled)),
                            rel: topic.is_disabled ? "nofollow" : "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTopicItem/* default */.Z, {
                                text: topic.name,
                                isActive: false,
                                color: "#000",
                                background: "#EEEBEB",
                                fontSize: 9
                            })
                        })
                    }, "topic-".concat(topic.id));
                })
            ]
        });
    }, [
        currentAuth,
        localPost.domains,
        localPost.symbols,
        router,
        showLogin
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PostDetails_module_default()).postDetailContentWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PostDetails_module_default()).centerColumn,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (PostDetails_module_default()).postWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaContent/* default */.ZP, {
                            localPost: localPost,
                            setSharedPost: setSharedPost,
                            sharedPost: sharedPost,
                            parent: api/* PostParentKey.PostDetail */.rO.PostDetail,
                            isContentLocked: isContentLocked,
                            isPostDetail: true,
                            isMobileScreen: isMobileScreen,
                            canSeeFreeMinutes: loadedPostWithAuth && canSeeFreeMinutes,
                            setCanSeeFreeMinutes: setCanSeeFreeMinutes,
                            loadedPostWithAuth: loadedPostWithAuth
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (PostDetails_module_default()).post,
                            style: tippedCount > 0 ? {
                                borderBottom: "1px solid #eee"
                            } : {},
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (PostDetails_module_default()).header,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfo/* default */.Z, {
                                            user: localPost.user_info,
                                            avatarSize: 64,
                                            hasFollowBtn: !isOwnPost,
                                            showMembershipIcon: false,
                                            badgeSize: 40,
                                            isAdsPost: localPost.is_affiliate,
                                            showLiveFlag: true,
                                            postedAt: localPost.is_affiliate ? "" : timeSinceText
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (PostDetails_module_default()).rightCorner,
                                            children: [
                                                showingPrimeSubBtnHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelButton/* default */.Z, {
                                                    type: "green-1",
                                                    text: "プライム登録",
                                                    className: (PostDetails_module_default()).primeSubBtn,
                                                    onClick: function() {
                                                        if (!currentAuth) {
                                                            showLogin({});
                                                            return;
                                                        }
                                                        showPaymentDialog({
                                                            creator: localPost.user_info
                                                        });
                                                    }
                                                }),
                                                loadedPostWithAuth && !isOwnPost && ((ref5 = localPost.user_info) === null || ref5 === void 0 ? void 0 : ref5.is_creator) && ((ref6 = localPost.user_info) === null || ref6 === void 0 ? void 0 : ref6.is_open_for_subscription) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelButton/* default */.Z, {
                                                    type: "pink",
                                                    className: (PostDetails_module_default()).thanksBtn,
                                                    onClick: function() {
                                                        trackAmpEvent("Click Thank Post Button");
                                                        if (!currentAuth) {
                                                            showLogin({});
                                                            return;
                                                        }
                                                        showTippingDialog({
                                                            post: localPost,
                                                            isStreaming: !!localPost.streaming
                                                        });
                                                    },
                                                    text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (PostDetails_module_default()).thanksIcon,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                                    name: "thanks-icon",
                                                                    width: 18,
                                                                    height: 18
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "ありがとう"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                (0,utils_post/* checkIsPaidPost */.P5)(localPost.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (PostDetails_module_default()).paidLabel,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaidLabel/* default */.Z, {
                                                        size: 28,
                                                        freeMinutesFontSize: 9,
                                                        freeMinutes: localPost.free_minutes || 0,
                                                        isGoldPost: localPost.type === api/* PostType.Gold */.hQ.Gold,
                                                        isPlusPost: localPost.type === api/* PostType.Plus */.hQ.Plus
                                                    })
                                                }),
                                                currentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (PostDetails_module_default()).threeDot,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeDotsMenu/* default */.Z, {
                                                        isOwnPost: isOwnPost,
                                                        isPostDetail: true,
                                                        postId: localPost.id,
                                                        userId: (ref7 = localPost.user_info) === null || ref7 === void 0 ? void 0 : ref7.id,
                                                        isSaved: localPost.is_saved,
                                                        isStreamingPost: !!localPost.streaming,
                                                        isAdsPost: localPost.is_affiliate,
                                                        onDelete: function() {
                                                            var ref;
                                                            return router.push("/".concat(((ref = localPost.user_info) === null || ref === void 0 ? void 0 : ref.username) || ""));
                                                        },
                                                        onBlock: function() {
                                                            return router.push("/");
                                                        },
                                                        isPinned: false,
                                                        onHide: function() {
                                                            return router.push("/");
                                                        },
                                                        isGoldPost: localPost.type === api/* PostType.Gold */.hQ.Gold,
                                                        isProcessing: localPost.status === api/* PostState.OnProcessing */.hA.OnProcessing,
                                                        onEdit: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                                            var ref, postData;
                                                            return runtime_default().wrap(function _callee$(_ctx) {
                                                                while(1)switch(_ctx.prev = _ctx.next){
                                                                    case 0:
                                                                        ;
                                                                        _ctx.next = 3;
                                                                        return (0,service_post/* getPostDetail */.si)(post.id, true);
                                                                    case 3:
                                                                        _ctx.t1 = ref = _ctx.sent;
                                                                        _ctx.t0 = _ctx.t1 === null;
                                                                        if (_ctx.t0) {
                                                                            _ctx.next = 7;
                                                                            break;
                                                                        }
                                                                        _ctx.t0 = ref === void 0;
                                                                    case 7:
                                                                        if (!_ctx.t0) {
                                                                            _ctx.next = 11;
                                                                            break;
                                                                        }
                                                                        _ctx.t2 = void 0;
                                                                        _ctx.next = 12;
                                                                        break;
                                                                    case 11:
                                                                        _ctx.t2 = ref.data;
                                                                    case 12:
                                                                        postData = _ctx.t2;
                                                                        if (isMobileScreen) {
                                                                            showCreatePostDialogMobile({
                                                                                post: postData || localPost,
                                                                                setLocalPost: setLocalPost,
                                                                                editMode: true,
                                                                                open: true
                                                                            });
                                                                        } else {
                                                                            showCreatePostDialog({
                                                                                post: postData || localPost,
                                                                                setLocalPost: setLocalPost,
                                                                                editMode: true,
                                                                                open: true
                                                                            });
                                                                        }
                                                                    case 14:
                                                                    case "end":
                                                                        return _ctx.stop();
                                                                }
                                                            }, _callee);
                                                        }))
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (!hasShortMode || !isShortMode) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (PostDetails_module_default()).actions,
                                    children: postTopicsList
                                }),
                                content,
                                openTippedList && /*#__PURE__*/ (0,jsx_runtime.jsx)(TippedListDialog/* default */.Z, {
                                    open: openTippedList,
                                    setOpen: setOpenTippedList,
                                    postId: localPost.id
                                })
                            ]
                        }),
                        !(isSmallScreen && isStreaming) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TippedListOfPost/* default */.Z, {
                            tippedList: tippedListOfPost,
                            tippedCount: tippedCount,
                            setOpenTippedList: setOpenTippedList
                        }),
                        !isStreaming && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPostReActions/* default */.Z, {
                            post: localPost,
                            isPostDetail: true,
                            showViewCount: !localPost.is_affiliate,
                            showNumber: true,
                            screen: pp_tracking/* ScreenName.PostDetail */.CG.PostDetail
                        }),
                        currentAuth && isSmallScreen && isStreaming && localPost && requestToken && (reloadingLiveChat ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PostDetails_module_default()).loading,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                name: "loading-anim-3",
                                width: 24,
                                height: 24
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(common_LiveStreamComments, {
                            className: (PostDetails_module_default()).postStreamComments,
                            post: localPost,
                            requestToken: requestToken,
                            tippedList: tippedListOfPost,
                            setOpenTippedList: setOpenTippedList,
                            tippedCount: tippedCount,
                            isLocked: isContentLocked && !canSeeFreeMinutes
                        })),
                        !isStreaming && (isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CommentsSection, {
                            localPost: localPost,
                            userWantShowComments: 0
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PostCommentsSection, {
                            localPost: localPost
                        })),
                        isStreaming && !isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                borderTop: "1px solid #eee"
                            }
                        }),
                        isSmallScreen && loadedPostWithAuth && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                marginTop: "15px"
                            },
                            children: relatedPosts(localPost)
                        })
                    ]
                })
            }),
            !isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PostDetails_module_default()).rightColumn,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (PostDetails_module_default()).rightSticky,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (PostDetails_module_default()).sectionWrapper,
                        children: [
                            currentAuth && isStreaming && localPost && requestToken && (reloadingLiveChat ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PostDetails_module_default()).loading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                    name: "loading-anim-3",
                                    width: 24,
                                    height: 24
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(common_LiveStreamComments, {
                                className: (PostDetails_module_default()).postStreamComments,
                                post: localPost,
                                requestToken: requestToken,
                                tippedList: tippedListOfPost,
                                setOpenTippedList: setOpenTippedList,
                                tippedCount: tippedCount,
                                isLocked: isContentLocked && !canSeeFreeMinutes
                            })),
                            loadedPostWithAuth && relatedPosts(localPost)
                        ]
                    })
                })
            })
        ]
    });
}
var relatedPosts = function(localPost) {
    var ref;
    if (!localPost || !localPost.id) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallPostsListSection, {
        apiUrl: "/posts/".concat(localPost.id, "/related_posts"),
        queryKey: [
            api/* PostParentKey.RelatedPosts */.rO.RelatedPosts,
            (ref = localPost.id) === null || ref === void 0 ? void 0 : ref.toString()
        ],
        disableInfiniteScroll: true,
        noResultMessage: "関連投稿はありません"
    });
};
var MemoizedPostDetails = /*#__PURE__*/ react.memo(PostDetails);
/* harmony default export */ var components_PostDetails = (MemoizedPostDetails);

// EXTERNAL MODULE: ./components/TimelineSection/index.tsx
var TimelineSection = __webpack_require__(32954);
// EXTERNAL MODULE: ./components/PostDetailsMobile/PostDetails.module.scss
var PostDetailsMobile_PostDetails_module = __webpack_require__(5839);
var PostDetailsMobile_PostDetails_module_default = /*#__PURE__*/__webpack_require__.n(PostDetailsMobile_PostDetails_module);
// EXTERNAL MODULE: ./components/PostDetailsMobile/TippedListOfPost/TippedListOfPost.module.scss
var TippedListOfPost_module = __webpack_require__(96961);
var TippedListOfPost_module_default = /*#__PURE__*/__webpack_require__.n(TippedListOfPost_module);
;// CONCATENATED MODULE: ./components/PostDetailsMobile/TippedListOfPost/index.tsx









var TippedListOfPost_TippedListOfPost = function(param) {
    var _tippedList = param.tippedList, tippedList = _tippedList === void 0 ? [] : _tippedList, _tippedCount = param.tippedCount, tippedCount = _tippedCount === void 0 ? 0 : _tippedCount, setOpenTippedList = param.setOpenTippedList;
    var ref;
    var listRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(5), maxItemsCount = ref1[0], setMaxItemsCount = ref1[1];
    var deviceInfo = (0,utils/* useDevice */.Fy)();
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = listRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth) {
            var itemWidth = deviceInfo.isIos ? 95 : 86;
            setMaxItemsCount(Math.floor(listRef.current.clientWidth / itemWidth - 1));
        }
    }, [
        (ref = listRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth,
        deviceInfo
    ]);
    var needShowMore = tippedCount > maxItemsCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TippedListOfPost_module_default()).tippedListWrapper,
        ref: listRef,
        children: tippedList.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (TippedListOfPost_module_default()).tippedList,
            children: [
                tippedList.slice(0, maxItemsCount).map(function(tippedInfo, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TippedItem/* default */.Z, {
                        className: (TippedListOfPost_module_default()).tippedLabel,
                        tippedInfo: tippedInfo
                    }, "tip-".concat(index));
                }),
                needShowMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelButton/* default */.Z, {
                    text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TippedListOfPost_module_default()).btnText,
                        children: [
                            "+",
                            tippedCount - maxItemsCount
                        ]
                    }),
                    className: classnames_default()((TippedListOfPost_module_default()).tippedLabel, (TippedListOfPost_module_default()).loadmoreBtn),
                    type: "gray",
                    onClick: function() {
                        return setOpenTippedList && setOpenTippedList(true);
                    }
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
};
/* harmony default export */ var PostDetailsMobile_TippedListOfPost = (TippedListOfPost_TippedListOfPost);

;// CONCATENATED MODULE: ./components/PostDetailsMobile/index.tsx





































function PostDetailsMobile_PostDetails(param) {
    var post = param.post, tippedListOfPost = param.tippedListOfPost, tippedCount = param.tippedCount, _loadedPostWithAuth = param.loadedPostWithAuth, loadedPostWithAuth = _loadedPostWithAuth === void 0 ? false : _loadedPostWithAuth;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    // Local post state so that edited content is shown immediately
    var ref8 = (0,react.useState)(post), localPost = ref8[0], setLocalPost = ref8[1];
    var ref9 = (0,react.useState)(false), openTippedList = ref9[0], setOpenTippedList = ref9[1];
    var showTippingDialog = (0,global/* default */.Z)(function(state) {
        return state.showTippingDialog;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var currentAuth = (0,global/* default */.Z)(function(state) {
        return state.currentAuth;
    });
    var refetchPost = (0,timeline/* default */.ZP)(function(state) {
        return state.refetchPost;
    });
    var refetchProfile = (0,timeline/* default */.ZP)(function(state) {
        return state.refetchProfile;
    });
    var router = (0,next_router.useRouter)();
    var isMobileScreen = (0,utils/* useMediaQuery */.ac)("(max-width: 767px)");
    var showCreatePostDialog = (0,global/* default */.Z)(function(state) {
        return state.showCreatePostDialog;
    });
    var ref10 = (0,react.useState)(false), reloadingLiveChat = ref10[0], setReloadingLiveChat = ref10[1];
    var ref11 = (0,react.useState)(false), canSeeFreeMinutes = ref11[0], setCanSeeFreeMinutes = ref11[1];
    var ref12 = (0,react.useState)(0), userWantShowComments = ref12[0], setUserWantShowComments = ref12[1];
    var requestToken = (0,global/* default */.Z)(function(state) {
        return state.requestToken;
    });
    var showCreatePostDialogMobile = (0,global/* default */.Z)(function(state) {
        return state.showCreatePostDialogMobile;
    });
    var showPaymentDialog = (0,global/* default */.Z)(function(state) {
        return state.showPaymentDialog;
    });
    var ref13 = (0,react.useState)(null), sharedPost = ref13[0], setSharedPost = ref13[1];
    var isOwnPost = localPost.is_my_post;
    var isContentLocked = (0,utils_post/* checkIsContentLocked */.J8)(localPost);
    var showingPrimeSubBtnHeader = !isOwnPost && loadedPostWithAuth && localPost.type === api/* PostType.Free */.hQ.Free && ((ref = localPost.user_info) === null || ref === void 0 ? void 0 : ref.is_creator) && ((ref1 = localPost.user_info) === null || ref1 === void 0 ? void 0 : ref1.is_open_for_subscription) && !localPost.is_subscription;
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    // post props may change
    (0,react.useEffect)(function() {
        setLocalPost(post);
        setUserWantShowComments(0);
    }, [
        post
    ]);
    var trackAmpEvent = function(eventName) {
        var ref, ref1, ref2, ref3, ref4;
        (0,esm/* track */.j)(eventName, {
            post_type: post.type,
            media_type: (ref = post.media) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.type,
            comment_count: post.comment_count,
            like_count: post.like_count,
            post_user_id: (ref2 = post.user_info) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.id) === null || ref3 === void 0 ? void 0 : ref3.toString(),
            is_followed: (ref4 = post.user_info) === null || ref4 === void 0 ? void 0 : ref4.is_followed
        });
    };
    var isStreaming = ((ref2 = localPost.streaming) === null || ref2 === void 0 ? void 0 : ref2.id) && ((ref3 = localPost.streaming) === null || ref3 === void 0 ? void 0 : ref3.status) === api/* LiveStreamStatus.InLive */.zN.InLive && !!((ref4 = localPost.streaming) === null || ref4 === void 0 ? void 0 : ref4.path_hls);
    (0,react.useEffect)(function() {
        if (!localPost.media || !localPost.media[0] || localPost.media[0].type !== api/* MediaType.Link */.DD.Link) {
            setSharedPost(null);
            return;
        }
    }, [
        localPost
    ]);
    var ref14 = (0,es.useMutation)(function() {
        return axios/* default.get */.Z.get("/posts/".concat(localPost.id, "?use_token=true"));
    }, {
        onSuccess: function() {
            refetchProfile();
            refetchPost();
        },
        onError: function() {
            setSnackbarMessage({
                type: "error",
                text: "エラーが発生しました"
            });
        }
    }), unlockPost = ref14.mutate, isUnlocking = ref14.isLoading;
    var ref15 = (0,react.useState)(true), isShortMode = ref15[0], setShortMode = ref15[1];
    var ref16 = (0,react.useState)(true), hasShortMode = ref16[0], setHasShortMode = ref16[1];
    var textRef = (0,react.useCallback)(function(node) {
        var initShortMode = setTimeout(function() {
            if (node !== null) {
                var scrollHeight = node.scrollHeight;
                var clientHeight = node.clientHeight;
                setHasShortMode(scrollHeight > clientHeight);
            }
        }, 500);
        return function() {
            return clearTimeout(initShortMode);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        localPost.text
    ]);
    (0,react.useEffect)(function() {
        setShortMode(true);
        setUserWantShowComments(0);
        setReloadingLiveChat(true);
        setTimeout(function() {
            setReloadingLiveChat(false);
        }, 2000);
    }, [
        post === null || post === void 0 ? void 0 : post.id
    ]);
    var _obj;
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((PostDetailsMobile_PostDetails_module_default()).postText, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (PostDetailsMobile_PostDetails_module_default()).locked, isContentLocked), (0,_define_property/* default */.Z)(_obj, (PostDetailsMobile_PostDetails_module_default()).notShortMode, !isShortMode), (0,_define_property/* default */.Z)(_obj, (PostDetailsMobile_PostDetails_module_default()).showingLoadmore, !isContentLocked && hasShortMode && isShortMode), _obj)),
                ref: textRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RichContent/* default */.Z, {
                        text: isContentLocked ? (0,utils/* lockTextContent */.QH)(localPost.text) : localPost.text
                    }),
                    !isContentLocked && hasShortMode && isShortMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PostDetailsMobile_PostDetails_module_default()).readmoreWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (PostDetailsMobile_PostDetails_module_default()).readmore,
                            onClick: function() {
                                trackAmpEvent("Click Read More In Post Detail");
                                if (!currentAuth) {
                                    showLogin({});
                                    return;
                                }
                                (0,utils/* increaseViewCount */.wh)(localPost.id);
                                setShortMode(false);
                            },
                            children: "続きを読む"
                        })
                    }),
                    isContentLocked && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PostDetailsMobile_PostDetails_module_default()).lockedOverlay
                    })
                ]
            }),
            sharedPost && (!hasShortMode || !isShortMode) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PostDetailsMobile_PostDetails_module_default()).sharedPost,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LitePost/* default */.Z, {
                    post: sharedPost,
                    parent: api/* PostParentKey.PostDetail */.rO.PostDetail,
                    showReadMore: true
                })
            }),
            !isContentLocked && hasShortMode && (isShortMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function() {
                    setShortMode(true);
                    window.scrollTo(0, 0);
                },
                className: (PostDetailsMobile_PostDetails_module_default()).showLess,
                children: "一部を表示"
            })),
            loadedPostWithAuth && (isContentLocked || !currentAuth) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginBottom: "2px"
                },
                children: localPost.type !== api/* PostType.Gold */.hQ.Gold && currentUser && typeof currentUser.referral_token === "number" && currentUser.referral_token > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (PostDetailsMobile_PostDetails_module_default()).referralTokenUse,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "招待チケットを使用して、あと",
                                currentUser.referral_token,
                                "回、無料で",
                                isMobileScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "プライム投稿をご覧いただけます"
                            ]
                        }),
                        isUnlocking ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "loading-anim-3",
                            width: 24,
                            height: 24
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function() {
                                return unlockPost();
                            },
                            children: "プライム投稿を見る"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LockedMessage, {
                    type: LockedType.Text,
                    postAuthor: localPost.user_info,
                    postType: localPost.type
                })
            })
        ]
    });
    // Right side components
    var isScheduledPost = new Date(localPost.created_at) > new Date();
    var timeSinceText = isScheduledPost ? "".concat((0,dayjs/* default */.Z)(localPost.created_at).format("YYYY/MM/DD HH:mm"), "に公開予定") : (0,utils/* timeSince */.VG)(new Date(localPost.created_at), api/* Language.Ja */.SQ.Ja);
    var postTopicsList = (0,react.useMemo)(function() {
        if ((!localPost.domains || localPost.domains.length === 0) && (!localPost.symbols || localPost.symbols.length === 0)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (PostDetailsMobile_PostDetails_module_default()).postTopicLists,
            children: [
                (localPost.symbols || []).map(function(symbol) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PostDetailsMobile_PostDetails_module_default()).item,
                        onClick: function() {
                            if (!currentAuth) {
                                showLogin({
                                    redirectUrl: "/chart?id=".concat(symbol.id, "&tab=chart")
                                });
                                return;
                            }
                            void router.push("/chart?id=".concat(symbol.id, "&tab=chart"));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTopicItem/* default */.Z, {
                            text: symbol.name,
                            isActive: false,
                            color: "#fff",
                            background: "#04b56a",
                            fontSize: 9
                        })
                    }, "symbol-".concat(symbol.name));
                }),
                (localPost.domains || []).map(function(topic) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/topic/".concat(topic.id),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: classnames_default()((PostDetailsMobile_PostDetails_module_default()).item, (0,_define_property/* default */.Z)({}, (PostDetailsMobile_PostDetails_module_default()).disabled, topic.is_disabled)),
                            rel: topic.is_disabled ? "nofollow" : "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTopicItem/* default */.Z, {
                                text: topic.name,
                                isActive: false,
                                color: "#000",
                                background: "#EEEBEB",
                                fontSize: 9
                            })
                        }, "topic-".concat(topic.id))
                    }, "topic-".concat(topic.id));
                })
            ]
        });
    }, [
        currentAuth,
        localPost.domains,
        localPost.symbols,
        router,
        showLogin
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PostDetailsMobile_PostDetails_module_default()).postWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaContent/* default */.ZP, {
                localPost: localPost,
                setSharedPost: setSharedPost,
                sharedPost: sharedPost,
                parent: api/* PostParentKey.PostDetail */.rO.PostDetail,
                isContentLocked: isContentLocked,
                isPostDetail: true,
                isMobileScreen: isMobileScreen,
                canSeeFreeMinutes: loadedPostWithAuth && canSeeFreeMinutes,
                setCanSeeFreeMinutes: setCanSeeFreeMinutes,
                loadedPostWithAuth: loadedPostWithAuth
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PostDetailsMobile_PostDetails_module_default()).post,
                style: tippedCount > 0 ? {
                    borderBottom: "1px solid #eee"
                } : {},
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((PostDetailsMobile_PostDetails_module_default()).header, (0,_define_property/* default */.Z)({}, (PostDetailsMobile_PostDetails_module_default()).showingSubBtn, showingPrimeSubBtnHeader)),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfo/* default */.Z, {
                                user: localPost.user_info,
                                avatarSize: 48,
                                showMembershipIcon: false,
                                hasFollowBtn: false,
                                badgeSize: 40,
                                showBadge: false,
                                isAdsPost: localPost.is_affiliate,
                                showLiveFlag: true,
                                postedAt: localPost.is_affiliate ? "" : timeSinceText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (PostDetailsMobile_PostDetails_module_default()).rightCorner,
                                children: [
                                    showingPrimeSubBtnHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelButton/* default */.Z, {
                                        type: "green-1",
                                        text: "プライム登録",
                                        className: (PostDetailsMobile_PostDetails_module_default()).primeSubBtn,
                                        onClick: function() {
                                            if (!currentAuth) {
                                                showLogin({});
                                                return;
                                            }
                                            showPaymentDialog({
                                                creator: localPost.user_info
                                            });
                                        }
                                    }),
                                    loadedPostWithAuth && !isOwnPost && ((ref5 = localPost.user_info) === null || ref5 === void 0 ? void 0 : ref5.is_creator) && ((ref6 = localPost.user_info) === null || ref6 === void 0 ? void 0 : ref6.is_open_for_subscription) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelButton/* default */.Z, {
                                        type: "pink",
                                        className: (PostDetailsMobile_PostDetails_module_default()).thanksBtn,
                                        onClick: function() {
                                            trackAmpEvent("Click Thank Post Button");
                                            if (!currentAuth) {
                                                showLogin({});
                                                return;
                                            }
                                            showTippingDialog({
                                                post: localPost,
                                                isStreaming: !!localPost.streaming
                                            });
                                        },
                                        text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (PostDetailsMobile_PostDetails_module_default()).thanksIcon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                        name: "thanks-icon",
                                                        width: 18,
                                                        height: 18
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "ありがとう"
                                                })
                                            ]
                                        })
                                    }),
                                    (0,utils_post/* checkIsPaidPost */.P5)(localPost.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (PostDetailsMobile_PostDetails_module_default()).paidLabel,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaidLabel/* default */.Z, {
                                            size: 28,
                                            freeMinutesFontSize: 9,
                                            freeMinutes: localPost.free_minutes || 0,
                                            isGoldPost: localPost.type === api/* PostType.Gold */.hQ.Gold,
                                            isPlusPost: localPost.type === api/* PostType.Plus */.hQ.Plus
                                        })
                                    }),
                                    currentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (PostDetailsMobile_PostDetails_module_default()).threeDot,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeDotsMenu/* default */.Z, {
                                            isOwnPost: isOwnPost,
                                            isPostDetail: true,
                                            postId: localPost.id,
                                            userId: (ref7 = localPost.user_info) === null || ref7 === void 0 ? void 0 : ref7.id,
                                            isSaved: localPost.is_saved,
                                            isStreamingPost: !!localPost.streaming,
                                            isAdsPost: localPost.is_affiliate,
                                            onDelete: function() {
                                                var ref;
                                                return router.push("/".concat(((ref = localPost.user_info) === null || ref === void 0 ? void 0 : ref.username) || ""));
                                            },
                                            onBlock: function() {
                                                return router.push("/");
                                            },
                                            isPinned: false,
                                            onHide: function() {
                                                return router.push("/");
                                            },
                                            isGoldPost: localPost.type === api/* PostType.Gold */.hQ.Gold,
                                            isProcessing: localPost.status === api/* PostState.OnProcessing */.hA.OnProcessing,
                                            onEdit: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                                var ref, postData;
                                                return runtime_default().wrap(function _callee$(_ctx) {
                                                    while(1)switch(_ctx.prev = _ctx.next){
                                                        case 0:
                                                            ;
                                                            _ctx.next = 3;
                                                            return (0,service_post/* getPostDetail */.si)(post.id, true);
                                                        case 3:
                                                            _ctx.t1 = ref = _ctx.sent;
                                                            _ctx.t0 = _ctx.t1 === null;
                                                            if (_ctx.t0) {
                                                                _ctx.next = 7;
                                                                break;
                                                            }
                                                            _ctx.t0 = ref === void 0;
                                                        case 7:
                                                            if (!_ctx.t0) {
                                                                _ctx.next = 11;
                                                                break;
                                                            }
                                                            _ctx.t2 = void 0;
                                                            _ctx.next = 12;
                                                            break;
                                                        case 11:
                                                            _ctx.t2 = ref.data;
                                                        case 12:
                                                            postData = _ctx.t2;
                                                            if (isMobileScreen) {
                                                                showCreatePostDialogMobile({
                                                                    post: postData || localPost,
                                                                    setLocalPost: setLocalPost,
                                                                    editMode: true,
                                                                    open: true
                                                                });
                                                            } else {
                                                                showCreatePostDialog({
                                                                    post: postData || localPost,
                                                                    setLocalPost: setLocalPost,
                                                                    editMode: true,
                                                                    open: true
                                                                });
                                                            }
                                                        case 14:
                                                        case "end":
                                                            return _ctx.stop();
                                                    }
                                                }, _callee);
                                            }))
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    (!hasShortMode || !isShortMode) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PostDetailsMobile_PostDetails_module_default()).actions,
                        children: postTopicsList
                    }),
                    content,
                    openTippedList && /*#__PURE__*/ (0,jsx_runtime.jsx)(TippedListDialog/* default */.Z, {
                        open: openTippedList,
                        setOpen: setOpenTippedList,
                        postId: localPost.id
                    })
                ]
            }),
            !isStreaming && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDetailsMobile_TippedListOfPost, {
                tippedList: tippedListOfPost,
                tippedCount: tippedCount,
                setOpenTippedList: setOpenTippedList
            }),
            !isStreaming && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPostReActions/* default */.Z, {
                post: localPost,
                isPostDetail: true,
                handleClickComment: function() {
                    return setUserWantShowComments(function(count) {
                        return count + 1;
                    });
                },
                showViewCount: !localPost.is_affiliate,
                showNumber: true,
                screen: pp_tracking/* ScreenName.PostDetail */.CG.PostDetail
            }),
            isStreaming && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    borderTop: "1px solid #eee"
                }
            }),
            !isStreaming && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CommentsSection, {
                localPost: localPost,
                userWantShowComments: userWantShowComments
            }),
            currentAuth && isStreaming && localPost && requestToken && (reloadingLiveChat ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PostDetailsMobile_PostDetails_module_default()).loading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: "loading-anim-3",
                    width: 24,
                    height: 24
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(common_LiveStreamComments, {
                className: (PostDetailsMobile_PostDetails_module_default()).postStreamComments,
                post: localPost,
                requestToken: requestToken,
                tippedList: tippedListOfPost,
                setOpenTippedList: setOpenTippedList,
                tippedCount: tippedCount,
                isLocked: isContentLocked && !canSeeFreeMinutes
            })),
            PostDetailsMobile_relatedPosts(localPost)
        ]
    });
}
var PostDetailsMobile_relatedPosts = function(localPost) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PostDetailsMobile_PostDetails_module_default()).relatedPosts,
        children: localPost && localPost.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineSection/* default */.Z, {
            apiUrl: "/posts/".concat(localPost.id, "/related_posts"),
            queryKey: [
                api/* PostParentKey.RelatedPosts */.rO.RelatedPosts,
                (ref = localPost.id) === null || ref === void 0 ? void 0 : ref.toString()
            ],
            hideNoResult: true,
            disableInfiniteScroll: true
        })
    });
};
var PostDetailsMobile_MemoizedPostDetails = /*#__PURE__*/ react.memo(PostDetailsMobile_PostDetails);
/* harmony default export */ var PostDetailsMobile = (PostDetailsMobile_MemoizedPostDetails);

// EXTERNAL MODULE: ./config/env.ts
var env = __webpack_require__(36514);
// EXTERNAL MODULE: ./pages/[username]/posts/PostDetailsPage.module.scss
var PostDetailsPage_module = __webpack_require__(10750);
var PostDetailsPage_module_default = /*#__PURE__*/__webpack_require__.n(PostDetailsPage_module);
// EXTERNAL MODULE: ./service/payment.ts
var service_payment = __webpack_require__(43827);
;// CONCATENATED MODULE: ./pages/[username]/posts/[postId].tsx

















var PostDetailsPage = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var userName = props.username;
    var postId = props.postId;
    var ref11 = (0,react.useState)((0,utils/* parseJSON */.Rx)(props.post)), post = ref11[0], setPost = ref11[1];
    var shouldRefetchPost = (0,timeline/* default */.ZP)(function(state) {
        return state.shouldRefetchPost;
    });
    var shouldRefetchTippedListOfPost = (0,timeline/* default */.ZP)(function(state) {
        return state.shouldRefetchTippedListOfPost;
    });
    var isMobile = (0,utils/* useMediaQuery */.ac)("(max-width: 767px)");
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var ref12 = (0,react.useState)(false), loadedPostWithAuth = ref12[0], setLoadedPostWithAuth = ref12[1];
    var ref13 = (0,es.useQuery)([
        "getPost",
        postId === null || postId === void 0 ? void 0 : postId.toString()
    ], (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (postId) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", Promise.reject());
                case 2:
                    return _ctx.abrupt("return", (0,service_post/* getPostDetail */.si)(postId));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        enabled: isAuthInit && !!postId,
        retry: false,
        onSuccess: function(data) {
            var post = data === null || data === void 0 ? void 0 : data.data;
            setPost(post);
            setTimeout(function() {
                setLoadedPostWithAuth(true);
            }, 500);
        },
        onError: function() {
            setLoadedPostWithAuth(true);
        },
        refetchOnWindowFocus: false
    }), refetch = ref13.refetch, isError = ref13.isError, isLoading = ref13.isLoading, isFetching = ref13.isFetching;
    var ref14 = (0,es.useQuery)([
        "getTippedListOfPost",
        post === null || post === void 0 ? void 0 : (ref = post.id) === null || ref === void 0 ? void 0 : ref.toString()
    ], (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (post) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", Promise.reject());
                case 2:
                    return _ctx.abrupt("return", (0,service_payment/* getTippedOfPost */.p3)(post.id, 1));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        enabled: isAuthInit && !!post,
        refetchOnWindowFocus: false
    }), refetchTippedList = ref14.refetch, tippedData = ref14.data;
    var tippedListOfPost = (tippedData === null || tippedData === void 0 ? void 0 : (ref1 = tippedData.data) === null || ref1 === void 0 ? void 0 : ref1.tipped_users) || [];
    var tippedCount = (tippedData === null || tippedData === void 0 ? void 0 : (ref2 = tippedData.data) === null || ref2 === void 0 ? void 0 : ref2.count) || 0;
    (0,react.useEffect)(function() {
        if (shouldRefetchPost) {
            void refetch();
        }
    }, [
        shouldRefetchPost,
        refetch
    ]);
    (0,react.useEffect)(function() {
        if (shouldRefetchTippedListOfPost) {
            void refetchTippedList();
        }
    }, [
        shouldRefetchTippedListOfPost,
        refetchTippedList
    ]);
    // Validate the current URL is followed `/[owner]/posts/[postId]`
    var isValidUrl = (post === null || post === void 0 ? void 0 : (ref3 = post.user_info) === null || ref3 === void 0 ? void 0 : ref3.username) === userName;
    // Metadata
    var user = post === null || post === void 0 ? void 0 : post.user_info;
    var baseTitleText = ((user === null || user === void 0 ? void 0 : user.name) ? user.name : "") + (user ? " | " : "") + "PostPrime";
    var ogpData = (0,utils/* ogpDataOfPost */.UN)(post);
    var titleText = ogpData.title ? "".concat(ogpData.title, " | ").concat(baseTitleText) : baseTitleText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: titleText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: ogpData.description ? "".concat(ogpData.description, " ...") : "ログインして、SNSでお金を学ぼう!"
                    }),
                    (ogpData.keywords || []).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: (ogpData.keywords || []).join(", ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "".concat(env/* SITE_BASE_URL */.B, "/").concat(userName, "/posts/").concat(postId)
                    }, "ogurl"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: ogpData.videoInfo ? "video.other" : "article"
                    }, "ogtype"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: titleText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: ogpData.description ? "".concat(ogpData.description, " ...") : "ログインして、SNSでお金を学ぼう!"
                    }),
                    ogpData.imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: ogpData.imageUrl || ""
                    }, "ogimage"),
                    ogpData.videoInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:video:url",
                                content: (ref4 = ogpData.videoInfo) === null || ref4 === void 0 ? void 0 : ref4.url
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:video:secure_url",
                                content: (ref5 = ogpData.videoInfo) === null || ref5 === void 0 ? void 0 : ref5.url
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:video:type",
                                content: (ref6 = ogpData.videoInfo) === null || ref6 === void 0 ? void 0 : ref6.type
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:video:width",
                                content: (ref7 = ogpData.videoInfo) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.width) === null || ref8 === void 0 ? void 0 : ref8.toString()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:video:height",
                                content: (ref9 = ogpData.videoInfo) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.height) === null || ref10 === void 0 ? void 0 : ref10.toString()
                            }),
                            (ogpData.keywords || []).map(function(keyword, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    property: "og:video:tag",
                                    content: keyword
                                }, "".concat(keyword, "-").concat(index));
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "".concat(env/* SITE_BASE_URL */.B, "/").concat(userName, "/posts/").concat(postId)
                    }, "twurl"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: titleText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: ogpData.description ? "".concat(ogpData.description, " ...") : "ログインして、SNSでお金を学ぼう!"
                    }),
                    ogpData.imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: ogpData.imageUrl || ""
                    }, "twimage"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "".concat(env/* SITE_BASE_URL */.B, "/").concat(userName, "/posts/").concat(postId)
                    })
                ]
            }),
            (!isValidUrl || isError) && !isLoading && !isFetching ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PostDetailsPage_module_default()).emptyWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "empty",
                        width: 96,
                        height: 96
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PostDetailsPage_module_default()).emptyText,
                        children: "この投稿は存在しません"
                    })
                ]
            }) : post && (isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDetailsMobile, {
                post: post,
                tippedListOfPost: tippedListOfPost,
                tippedCount: tippedCount,
                loadedPostWithAuth: loadedPostWithAuth
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PostDetails, {
                post: post,
                tippedListOfPost: tippedListOfPost,
                tippedCount: tippedCount,
                loadedPostWithAuth: loadedPostWithAuth
            }))
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _postId_ = (PostDetailsPage);


/***/ }),

/***/ 48201:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"comments":"CommentsSection_comments__c_Klh","tinyMode":"CommentsSection_tinyMode__YutLQ","commentBoxWrapper":"CommentsSection_commentBoxWrapper__q3HfS","comment":"CommentsSection_comment__1kELi","more":"CommentsSection_more__GNgkG"};

/***/ }),

/***/ 98089:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"comments":"CommentsSection_comments__36FbE","tinyMode":"CommentsSection_tinyMode__kk9tm","commentBoxWrapper":"CommentsSection_commentBoxWrapper__q6p6F","comment":"CommentsSection_comment__nRXF8","more":"CommentsSection_more__O9Ljz"};

/***/ }),

/***/ 8577:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"postDetailContentWrapper":"PostDetails_postDetailContentWrapper__9Tx9x","loading":"PostDetails_loading__mKfdR","rightColumn":"PostDetails_rightColumn__QrjZ4","rightSticky":"PostDetails_rightSticky__PE0HU","trendingPosts":"PostDetails_trendingPosts__uguOC","sectionWrapper":"PostDetails_sectionWrapper__r_dSA","noData":"PostDetails_noData__7Y6UN","sectionTitleWrapper":"PostDetails_sectionTitleWrapper___11da","sectionTitle":"PostDetails_sectionTitle__bFgSO","postStreamComments":"PostDetails_postStreamComments__J3YAJ","centerColumn":"PostDetails_centerColumn__zUrUl","postWrapper":"PostDetails_postWrapper__BstHV","post":"PostDetails_post__G6QyN","header":"PostDetails_header__BECwW","showingSubBtn":"PostDetails_showingSubBtn__atadt","rightCorner":"PostDetails_rightCorner__fbLw_","primeSubBtn":"PostDetails_primeSubBtn__HHT_C","paidLabel":"PostDetails_paidLabel__WHNVo","threeDot":"PostDetails_threeDot__RQvhh","thanksBtn":"PostDetails_thanksBtn__wfl68","thanksIcon":"PostDetails_thanksIcon___K_Je","actions":"PostDetails_actions__SpSGF","rightSide":"PostDetails_rightSide__nXGWn","timeSince":"PostDetails_timeSince__u_ofB","postText":"PostDetails_postText___IExn","notShortMode":"PostDetails_notShortMode__kQtMb","locked":"PostDetails_locked__m347O","lockedOverlay":"PostDetails_lockedOverlay__HQ7cE","showingLoadmore":"PostDetails_showingLoadmore__F1q1r","readmoreWrapper":"PostDetails_readmoreWrapper__Dff5J","readmore":"PostDetails_readmore__S_Stl","showLess":"PostDetails_showLess__A73m9","sharedPost":"PostDetails_sharedPost__VpCw2","symbol":"PostDetails_symbol__gyPXA","postTopicLists":"PostDetails_postTopicLists__yqX6Z","item":"PostDetails_item__SLmwG","itemLink":"PostDetails_itemLink__4ywJd","disabled":"PostDetails_disabled__pdkTP","referralTokenUse":"PostDetails_referralTokenUse__hgmeD","recommenedSection":"PostDetails_recommenedSection__cqh9p","title":"PostDetails_title__pWZk_","subtitle":"PostDetails_subtitle__qMIhj","recommendedPosts":"PostDetails_recommendedPosts__soOfw","recommendedPost":"PostDetails_recommendedPost__2X_Tv","sectionHeader":"PostDetails_sectionHeader__OLj_A","icon":"PostDetails_icon__AzlUQ","relatedPosts":"PostDetails_relatedPosts__p_8DU","leftColumn":"PostDetails_leftColumn__ZYe59","leftSticky":"PostDetails_leftSticky__nPbH3"};

/***/ }),

/***/ 5839:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading":"PostDetails_loading__GdbEQ","postWrapper":"PostDetails_postWrapper__L3SRo","post":"PostDetails_post__6VR27","header":"PostDetails_header__LOXel","rightCorner":"PostDetails_rightCorner__lS81V","threeDot":"PostDetails_threeDot___pElh","primeSubBtn":"PostDetails_primeSubBtn__JZnjC","paidLabel":"PostDetails_paidLabel__0hQSQ","timeSince":"PostDetails_timeSince__B7xqG","thanksBtn":"PostDetails_thanksBtn__CQ9rH","thanksIcon":"PostDetails_thanksIcon__iysY6","actions":"PostDetails_actions__9xcsR","rightSide":"PostDetails_rightSide__v4WEB","postText":"PostDetails_postText__d20O5","notShortMode":"PostDetails_notShortMode__RMzQU","locked":"PostDetails_locked__Lqct6","lockedOverlay":"PostDetails_lockedOverlay__IRsTU","showingLoadmore":"PostDetails_showingLoadmore__jEP_J","readmoreWrapper":"PostDetails_readmoreWrapper__BgSa8","readmore":"PostDetails_readmore__HEZ2h","showLess":"PostDetails_showLess__dK_vb","sharedPost":"PostDetails_sharedPost__gejxA","postTopicLists":"PostDetails_postTopicLists__9KZ8C","item":"PostDetails_item__PBdEK","itemLink":"PostDetails_itemLink__ASzh7","disabled":"PostDetails_disabled__lLFwK","referralTokenUse":"PostDetails_referralTokenUse___tj6d","recommenedSection":"PostDetails_recommenedSection__QNXWJ","title":"PostDetails_title__nxp4D","subtitle":"PostDetails_subtitle__PvvDH","recommendedPosts":"PostDetails_recommendedPosts__EId_E","recommendedPost":"PostDetails_recommendedPost__ZOJ_d","sectionHeader":"PostDetails_sectionHeader__yK3Kz","icon":"PostDetails_icon__RlgR9","comments":"PostDetails_comments__DZLXJ","tinyMode":"PostDetails_tinyMode__fS2mr","commentBoxWrapper":"PostDetails_commentBoxWrapper__ZGX8D","comment":"PostDetails_comment__Qq8we","more":"PostDetails_more___Apkx"};

/***/ }),

/***/ 96961:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tippedListWrapper":"TippedListOfPost_tippedListWrapper__xkVP2","tippedList":"TippedListOfPost_tippedList__GNoFa","tippedLabel":"TippedListOfPost_tippedLabel__M_Elp","tippedIcon":"TippedListOfPost_tippedIcon__gg6We","loadmoreBtn":"TippedListOfPost_loadmoreBtn__ibHRD","btnText":"TippedListOfPost_btnText__jk1dN"};

/***/ }),

/***/ 92238:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"noPost":"SmallPostsListSection_noPost__QmP_M","post":"SmallPostsListSection_post__CZqn7"};

/***/ }),

/***/ 16081:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"noPost":"TimelineSection_noPost__Oy64j","post":"TimelineSection_post__St5uN"};

/***/ }),

/***/ 21994:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"commentSection":"LiveStreamComments_commentSection__iEdew","title":"LiveStreamComments_title__trTwh","tippedList":"LiveStreamComments_tippedList__DoSMb","tippedLabel":"LiveStreamComments_tippedLabel__mS_XC","loadmoreBtn":"LiveStreamComments_loadmoreBtn__7EEP2","btnText":"LiveStreamComments_btnText__wliUR","tippedIcon":"LiveStreamComments_tippedIcon__P2i8y","commentsList":"LiveStreamComments_commentsList__BuZ4p","comment":"LiveStreamComments_comment__QDg_9","tip-3":"LiveStreamComments_tip-3__1axgm","tip-4":"LiveStreamComments_tip-4__n6zwC","tip-5":"LiveStreamComments_tip-5__l1ppS","avatar":"LiveStreamComments_avatar__L5ESh","rightSide":"LiveStreamComments_rightSide__CzyQt","content":"LiveStreamComments_content__ZOgMc","userName":"LiveStreamComments_userName__Smtkh","commentText":"LiveStreamComments_commentText__uGWwn","tipContent":"LiveStreamComments_tipContent__udYxK","empty":"LiveStreamComments_empty__y_3d3","actionBox":"LiveStreamComments_actionBox__et9bu","postReactions":"LiveStreamComments_postReactions__SgjHI","action":"LiveStreamComments_action__b45_i","numberWrapper":"LiveStreamComments_numberWrapper__W79Dl","thanks":"LiveStreamComments_thanks__aUnUr","disabled":"LiveStreamComments_disabled__wcGzY","shareMenuTrigger":"LiveStreamComments_shareMenuTrigger__HPWo6","shareMenuWrapper":"LiveStreamComments_shareMenuWrapper__Kb_rN","option":"LiveStreamComments_option__FPqbk","icon":"LiveStreamComments_icon__8QvCJ","text":"LiveStreamComments_text__Rd_ve"};

/***/ }),

/***/ 77037:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lockedOverlay":"LockedMessage_lockedOverlay__ILTCh","image":"LockedMessage_image__ugqnd","text":"LockedMessage_text__owM3B","icon":"LockedMessage_icon__Egj1U","round":"LockedMessage_round__Wy4fU","desc":"LockedMessage_desc__cf4lA","loginText":"LockedMessage_loginText___80S4","btn":"LockedMessage_btn__NUMMG","registerBtn":"LockedMessage_registerBtn__KBEE9"};

/***/ }),

/***/ 26759:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"postTopicItem":"PostTopicItem_postTopicItem__1a890","active":"PostTopicItem_active__B987A"};

/***/ }),

/***/ 72308:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"smallPostWrapper":"SmallPost_smallPostWrapper__2hgY_","contentWrapper":"SmallPost_contentWrapper__HovIQ","userInfo":"SmallPost_userInfo__wXFJt","userNameText":"SmallPost_userNameText__RsZgu","userJobText":"SmallPost_userJobText__kNOB_","postTextWrapper":"SmallPost_postTextWrapper__pC3TW","postText":"SmallPost_postText__Rbsse","thumbnail":"SmallPost_thumbnail__19Fj_","media":"SmallPost_media__D6hxq","imageWrapper":"SmallPost_imageWrapper__MzEsl","blurred":"SmallPost_blurred__MNUoM","playBtn":"SmallPost_playBtn__KKe6x"};

/***/ }),

/***/ 10750:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"emptyWrapper":"PostDetailsPage_emptyWrapper__JM73U","emptyText":"PostDetailsPage_emptyText__ummtx"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6007,6310,9122,4850,5489,7676,176,453,7393,3962,9847,7268,9774,2888,179], function() { return __webpack_exec__(21926); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);